const translations = {
  //sidebar
  dashboard: "Dashboard",
  roleManagement: "Role Management",
  userManagement: "User Management",
  subUserManagement: "Sub-User Management",
  UserAndRoleManagement: "User And Role Management",
  admin: "Admin",
  landManagement: "Land Management",
  landMaster: "Land Master",
  villageManagement: "Village Management",
  typeManagement: "Type Management",
  land: "Land",
  administration: "Administration",
  ownerManagement: "Area Unit",
  measurementList: "Joint Measurement Report (JMR)",
  projects: "Projects",
  projectmanagement: "Project Management",
  landholdingList: "Land Holder's Detail",
  praposal: "Praposal",
  acquisitionrecords: "Proposal Review",
  finalaward: "Final-Award",
  Payment: "Payment",
  KJP: "KJP",
  workManagement: "Work Management",
  objectionList: "Sec-15 Objection ",
  reports: "Reports",
  landAcquisitions: "Land Acquisition Management",
  informationSystem: "Land Acquisition Portal",
  logout: "Logout",

  ProposalManagement: "Proposal Management",
  Assign: "Assign",
  DirectPurchase: "Purchase Sales Details",
  ProposalPublicationPreliminaryNotification: "Publication Preliminary Notification",
  KabjaPauti: "Kabja Pavti",
  PAP: "Project Affected Person",
  ProjectAffectedPerson: "Project Affected Person",
  SearchBar: "Search Bar",
  Version: "Version",
  PunavarshanManagement: "Punarvasan Management",

  DetailsOfLandToBeAcquire: "Details of Land To be Acquire",
  DetailsOfLandToBeAcquirePI: "Details of Proposal",
  AddLandholdingAcquisition: "Add Landholding Acquisition",
  EditLandholdingAcquisition: "Edit Landholding Acquisition",
  LandTypeManagement: "Land Type Management",
  MeasurementWiseObjection: "Measurement Wise Objection",
  GeneralObjection: "General Objection",
  CreateProject: "Create Project",
  EditProject: "Edit Project",
  Hearing: "Hearing",
  GeneralObjectionForm: "General Objection Form",
  PrivateObjectionForm: "Private Objection Form",
  MeasurementWiseObjectionForm: "Measurement Wise Objection Form",
  JointMeasurementList: "Joint Measurement List",
  JointMeasurementDetails: "JMR",
  MarketValueBail: "Market Value of Land",
  levy: "Hectare Rate",
  MarketValue: "Market value of land",
  AdvancePayment: "Advance payment distribution",
  AcquisitionAreaToAcquirableArea: "Acquirable Area",
  ReportLandAcquisition: "Report Land Acquisition",
  Section11: "Section 11",
  Parishtisht1Notice: "Appendix 1",
  Anusuchi2: "Appendix 2",
  Anusuchi3: "Appendix 3",
  Anusuchi4: "Appendix 4",
  Anusuchi5: "Appendix 5",
  Parishtisht6Notice: "Appendix 6",
  Anusuchi7: "Appendix 7",
  CompensationAmount: "Compensation",
  Compensation: "Compensation",
  FinalReward: "Final Reward",
  ConcernValuer: "Concern Valuer",
  Proposal: "Proposal",
  PublicationPreliminaryNotification: "Section-11 Notification",
  Punavarshan: "Punarvasan Certificate",
  AddProposal: "Add Proposal",
  ViewProposal: "View Proposal",

  // Section93
  Section93: "Section 93",

  //Navbar
  Stage: "Stage",
  NavProposalNo: "Bhusampadan Proposal No",
  Bhusampadan: "Case No",
  Date: "Date",
  SelectLanguage: "Select Language",
  Profile: "Profile",
  Settings: "Settings",
  SignOut: "Sign Out",
  SigningOut: "Signing out...",
  completedProposals: "Completed Proposals",

  //AcquisitionRecords
  landRecordsData: "Schedule - One",
  landSerialNo: "A.No.",
  landGatNo: "Group no.",
  landArea: "Land Area",
  Actions: "Actions",
  editRecord: "Edit Record",
  saveRecord: "Save Changes",
  cancelRecord: "Cancel",
  updateMessage: "Record updated successfully.",
  TotalSurveyGat: "Total Survey/ Gat",
  ScheduleOnePreview: "Schedule - One Preview",
  SelectDistrict: "Select District",
  SelectTaluka: "Select Taluka",
  SelectVillage: "Select Village",
  LoadingDistricts: "Loading Districts",
  LoadingTalukas: "Loading Talukas",
  LoadingVillages: "Loading Villages",
  LoadingLandRecords: "Loading land records",
  DownloadReport: "Download Report",
  SendToCollector: "Send to Res.Collector",
  SendToProjectIncharge: "Send to ProjectIncharge",
  Checking: "Checking...",
  SrNo: "Sr.No.",
  SurveyNo: "Survey No.",
  Area: "Area",
  Action: "Action",
  TotalHoldings: "Total Holdings",
  TotalArea: "Total Area",
  IrrigativeArea: "Cultivable Area",
  AcquisitionArea: "Acquisition Area",
  ProposeLAOOfficer: "Propose LAO Officer",
  SelectLAOOfficer: "Select LAO Officer",
  LoadingLAOUsers: "Loading LAO users...",
  SelectCollector: "Select Collector *",
  LoadingUsers: "Loading users...",
  SelectCollectorUser: "Select Res.Collector",
  Remarks: "Remarks",
  UploadDocument: "Upload Document",
  Selected: "Selected",
  Cancel: "Cancel",
  DocumentPreview: "Document Preview",

  Filters: "Filters",
  Sending: "Sending...",
  SendToSamanvayOfficer: "Send to Samanvay Officer",
  Assigning: "Assigning...",
  AssignLAOOfficer: "Assign LAO Officer",
  FilterByLocation: "Filter by Location",
  AllRecords: "All Records",
  SelectLocation: "Select Location",
  PleaseSelectAll: "Please select District, Taluka, and Village to view land records",
  ShowingDataFor: "Showing data for",
  NoLandRecordsForProject: "No land records are available for the selected location in project:",
  TryAnother: "Try selecting a different location or change the project from the dashboard.",
  NoLandRecords: "No land records are available for the selected location.",
  LocationSelectionRequired: "Location Selection Required",
  PleaseSelectFromFilter: "Please select District, Taluka, and Village from the filter panel above to view land records.",
  NoRecordsFound: "No Records Found",
  Column: "Column",
  Assigned: "Assigned",
  selectFormat: "Draft Award",
  pdfFormat: "PDF Format",
  pdfNote: "For printing purposes",
  csvFormat: "CSV Format",
  csvNote: "For opening in Excel",
  success: "Success",
  Confirm: "Confirm",
  confirmResubmission: "Confirm Re-submission",
  resubmissionWarning: "You have already sent this proposal once. Are you sure you want to send it again?",


  //AddLandholdingList
  addNewLandholding: "Add New Landholding",
  heading: "Enter information about the new landholding record",
  LandNo: "Land Acq No",
  landholderName: "Landholder's Name",
  VillageName: "Village Name",
  DistrictName: "District Name",
  TAlukaName: "Taluka Name",
  AddSurveyGatNo: "Gat/Survey No",
  IrrigableArea: "Cultivable Area",
  NonIrrigableArea: "Non-Cultivable Area",
  AcquiredArea: "Acquired Area",
  Status: "Status",
  Active: "Active",
  inactive: "Inactive",
  EnterName: "Enter name",
  EnterCultivableArea: "Enter Cultivable Area",
  EnterNonCultivableArea: "Enter Non-Cultivable Area",
  SelectLandholdingType: "Select Landholding Type",
  North: "North",
  EnterNorth: "Enter North",
  East: "East",
  EnterEast: "Enter East",
  West: "West",
  EnterWest: "Enter West",
  South: "South",
  EnterSouth: "Enter South",
  EnterTotalArea: "Enter total area",
  EnterAcquiredArea: "Enter acquired area",
  EnterSurveyNo: "Enter Survey No",
  EnterIrrigableeArea: "Enter Irrigable Area",
  EnterNonIrrigableArea: "Enter Non-Irrigable Area",
  AreaUnit: "Area Unit",
  SelectAreaUnit: "Select Area Unit",
  PleaseSelectAreaUnitFirst: "Please select area unit first",
  Maximum: "Maximum",
  UseCommasToSeparateNames: "Use commas to separate multiple names",
  Saving: "Saving...",
  Save: "Save",
  Add: "Add",
  Warning: "Warning",
  Okay: "Okay",

  //AdminDashboard
  filter: "Filter",
  AddNewProject: "Add Project",
  totalProjects: "Total Projects",
  newProjectsThisMonth: "3 New Projects this month",
  totalVillages: "Total Villages",
  updatedToday: "Updated Today",
  landOwners: "Land Owners",
  ownersAddedThisWeek: "+45 added this week",
  landType: "Land Type",
  landTypeExamples: "Agriculture, Forest, Industrial...",
  assignedWorks: "Assigned Works",
  inProgress: "In Progress",
  pendingNOCs: "Pending NOCs",
  awaitingDocuments: "5 awaiting documents",
  activeAdminUsers: "Active Admin Users",
  lastLogin: "Last login: 10 mins ago",
  projectProgress: "Project Progress",
  overallAcquisitionStatus: "Overall Acquisition Status",
  growthVsLastMonth: "Growth • vs last month",
  decreaseVsLastMonth: "Decrease • vs last month",
  stableVsLastMonth: "Stable • vs last month",
  recentProjectsActivities: "Recent Projects Activities",
  Category: "Category",
  viewAll: "View All",
  showingProjects: "Showing 5 of 24 projects",

  projectCompletionTrend: "Project Completion Trend",
  projectCompletionChart: "Project Completion Chart",
  last6Months: "Last 6 months",
  lastyear: "Last Year",
  alltime: "All Time",

  landTypeDistribution: "Land Type Distribution",
  landTypes: {
    agricultural: "Agricultural",
    urban: "Urban",
    industrial: "Industrial"
  },

  statuses: {
    active: "Active",
    onHold: "On Hold"
  },

  actions: {
    edit: "Edit",
    delete: "Delete"
  },
   edit: "Edit",

  allProjects: "All Projects",
  activePeojects: "Active Projects",
  completedProjects: "Completed Projects",

  ProposalChangeRequired: "Proposal Change Required",
  DifferentProposalDetected: "Different proposal detected",
  SwitchToDifferentProposal: "Switch to Different Proposal?",
  ProposalWarningMsg: "The tracking item you clicked belongs to a different proposal than your currently selected one.",
  CurrentProposal: "Current Proposal",
  TargetProposal: "Target Proposal",
  WhatHappensOnProceed: "What happens when you proceed?",
  SwitchInfo: "Your active proposal will be switched to the target proposal, and you'll be navigated to the corresponding stage.",
  SwitchContinue: "Switch & Continue",
  Completed: "Completed",
  StageProgress: "Stage Progress",
  CompletionRate: "Completion Rate",
  NoProjectData: "No Project Data Available",
  Project: "Project",
  NoProgressData: "No Progress Data Available",
  ProjectStages: "project stages",
  Village: "Village",
  Back: "Back",
  ItemsPerPage: "Items per page",
  Proposals: "proposals",
  NavigateMsg: "Click on any row to navigate to the corresponding stage (based on your role permissions)",
  TryAgain: "Try Again",
  ProposalID: "Proposal ID",
  ProposalNo: "Proposal Name",
  StageTransition: "Stage Transition",
  DateTime: "Date & Time",
  ProposalDate: "Proposal Date",
  Location: "Location",
  From: "From",
  To: "to",
  Document: "Document",
  NoDocument: "No document",
  ClickToViewTracking: "Click on any proposal to view its tracking activities",
  Showing: "Showing",
  Of: "of",
  TotalProposals: "Total Proposals",
  Page: "page",
  Previous: "Previous",
  Pre: "Previous",
  Next: "Next",
  GoToPage: "Go to page:",
  ShowingTracking: " tracking activities for this proposal",
  LandToBeAcquired: "Land To Be Acquired",
  LandParcelsEntered: "Land parcels Entered (Survey No./Gat No.)",
  JMR: "JMR",
  JMRCompleted: "JMR Completed parcels (Survey No./Gat No.)",
  CompensationCompleted: "Compensation Completed parcels (Survey No./Gat No.)",
  FinalAward: "Final Award",
  FinalAwardCompleted: "Final award Completed parcels (Survey No./Gat No.)",
  AdminSection11: "Section 11",
  AdminSection12: "Section 12",
  AdminSection15: "Section 15",
  AdminSection19: "Section 19",
  PaymentPossession: "Section 21",
  AdminSection23: "Section 23",
  Other: "Other",
  PaymentCompleted: "Payment Completed parcels (Survey No./Gat No.)",
  SelectProject: "Select Project",
  ID: "ID",
  Type: "Type",
  LoadingProjects: "Loading projects...",
  Retry: "Retry",
  Progress: "Progress",
  NoProjectsAvailable: "No Projects available",
  SelectProposalNo: "Select Proposal No (optional)",
  LoadingProposals: "Loading proposals...",
  NoProposalsAvailable: "No proposals available",
  ProceedWithProject: "You can still proceed with just the project",
  NoProposalSelected: "No proposal selected (proceed with project only)",
  NoProposalsFound: "No proposals found for this project",
  Updating: "Updating...",
  Refresh: "Refresh",
  ChangeProject: "Change Project",
  Summary: "Summary",
  DashboardSummary: "Completed Awards",
  publicDocument: "Public Document Portal",
  ViewDocument: "View Document",
  completedAward: "Completed Award",
  completedPortel: "Land Acquisition Records",
  Dashboard: "DASHBOARD",
  ProposalTrend: "Proposal Completion Trend",
  Loading: "Loading...",
  ProposalProgress: "Proposal Progress",
  DocumentViewer: "Document Viewer",
  OpenOriginal: "Open Original",
  ImageLoadFailed: "Failed to load image",
  PreviewNotAvailable: "Preview not available",
  CannotPreview: "This document type cannot be previewed in the browser",
  DownloadOpen: "Download & Open",

  recentProposalActivities: "Recent Proposal Activities",
  acquireArea: "Acquire Area",
  landOwner: "Land Owner",
  loadingProposalActivities: "Loading recent proposal activities...",
  loadingTrackingActivities: "Loading proposal tracking activities...",
  changeProject: "Change Project",
  selectProject: "Select Project",
  chooseProjectOptional: "Choose a different project (proposal is optional)",
  chooseProjectContinue: "Choose a project to continue to the dashboard (proposal is optional)",
  continue: "Continue",
  pspvp: "Please select a project to view progress",


  //CreateProject

  addProject: "Add Project",
  addProjectDescription: "Create a new project with detailed information and assign it to a specific state and village.",

  BasicInformation: "Basic Information",
  projectNamePlaceholder: "Enter project name",
  ProjectId: "Project ID",
  projectIdPlaceholder: "Enter unique project ID",
  categoryPlaceholder: "Select a category",
  agriculture: "Agriculture",
  education: "Education",
  healthcare: "Healthcare",
  infrastructure: "Infrastructure",
  water: "Water",
  energy: "Energy",
  projectManager: "Project Manager",
  projectManagerPlaceholder: "Enter project Incharge's name",

  Description: "Description",
  projectDescription: "Project Description",
  projectDescriptionPlaceholder: "Enter detailed description",
  tags: "Tags",
  tagsPlaceholder: "Enter tags separated by commas",

  timelineAndStatus: "Timeline & Status",
  startDate: "Start Date",
  endDate: "End Date",
  viewProgress: "View Progress",
  priority: "Priority",

  pending: "Pending",
  Ongoing: "Ongoing",
  planning: "Planning",
  onhold: "On Hold",
  cancelled: "Cancelled",  
  urgent: "Urgent",
  state: "State",
  statePlaceholder: "Enter state",
  districtPlaceholder: "Enter district",
  villageTown: "Village/Town",
  villageTownPlaceholder: "Enter village or town",

  financialDetails: "Financial Details",
  budget: "Budget (₹)",
  budgetPlaceholder: "Enter budget amount",
  stakeholders: "Stakeholders",
  stakeholdersPlaceholder: "Enter stakeholder organizations",
  projectAdministration: "Project Administration",
  projectArea: "Project Area (sq. km)",
  projectAreaPlaceholder: "Enter project coverage area",
  programBy: "Program By",
  programByPlaceholder: "Enter implementing organization/department",
  sequenceOrder: "Sequence/Order",
  sequenceOrderPlaceholder: "Denotes order in project listing",

  projectDocuments: "Project Documents",
  uploadFiles: "Upload Files",
  noFileSelected: "No file selected",
  submitProject: "Submit Project",
  EnterProjectName: "Enter project name (e.g., Metro Expansion Phase 1)",
  ProjectType: "Project Type",
  SelectProjectType: "Select project type",
  ProjectDivision: "Project Division",
  StateGovUT: "State Government/Union Territories",
  PublicWorksDivision: "Public Works Division",
  UrbanDevDivision: "Urban Development Division",
  RuralDevDivision: "Rural Development Division",
  IndustrialDevDivision: "Industrial Development Division",
  ProjectIncharge: "Project Incharge",
  LoadingManagers: "Loading available project managers...",
  Creating: "Creating...",
  LoadingProjectManagers: "Loading project managers...",
  SelectProjectIncharge: "Select project incharge",
  SelectDivision: "Select division",


  //EditLandholdinglist
  EditLandholding: "Edit Landholding",
  irrigableArea: "Cultivable Area",
  nonIrrigableArea: "Non-Cultivable Area",
  saveChanges: "Save Changes",
  Loadinglandholdingdata: "Loading landholding data...",
  Edit: "Edit",
  WarningNolandIDavailableUpdatesmaynotworkproperly: "Warning: No land ID available. Updates may not work properly.",
  Reload: "Reload",
  SurveyType: "Survey Type",
  SelectSurveyType: "Select Survey Type",
  GatNo: "Gat No",
  PlotNo: "Plot No",
  GharNo: "Ghar No",
  Loadingareaunits: "Loading area units...",
  Entertotalareain: "Enter total area in",
  Enteracquiredareain: "Enter acquired area in",
  Enterirrigableareain: "Enter Cultivable area in",
  LandOccupants: "Land Occupants",
  AddOccupant: "Add Occupant",
  AllAreasDistributed: "All areas have been distributed",
  NoLandIdAvailable: "No land ID available",
  AddNewOccupant: "Add new occupant",
  TotalAreaDistributionSummary: "Total Area Distribution Summary",
  LandTotalArea: "Land Total Area",
  DistributedToOwners: "Distributed to Occupants",
  Remaining: "Remaining",
  AllAreaDistributed: "All land total area has been distributed among occupants",
  AcquiredAreaDistributionSummary: "Acquired Area Distribution Summary",
  LandAcquiredArea: "Land Acquired Area",
  DistributedAcquiredToOwners: "Distributed to Occupants",
  RemainingAcquired: "Remaining",
  AddNewOccupantBtn: "Add New Occupant",
  OwnerName: "Owner Name",
  LimitedByRemainingAcquired: "Limited by remaining acquired",
  Max: "Max",
  OwnersTotal: "Occupant's total",
  Adding: "Adding...",
  EditOccupant: "Edit Occupant",
  MaxAvailable: "Max Available",
  LimitedByAvailableAcquired: "Limited by available acquired",
  UpdateOccupant: "Update Occupant",
  ExistingOwners: "Existing Occupant",
  DeleteOccupant:"Delete Occupant",
  Number1: "No",
  NoOwnersFound: "No owners found for this landholding",



  //GeneralObjection
  formTitle: "General Objection Form",
  formSubtitle: "Submit your objection details",
  ObjectionInformation: "Objection Information",
  objectionDate: "Objection Date",
  affectedSurveyNo: "Affected Survey No.",
  SupportingDocumentsReferences: "Supporting Documents & References",

  ObjectorDetails: "Objector Details",
  objectorName: " Objector Name",
  objectorAddress: "Objector Address",
  contactNumber: "Contact No.",
  Entermobilenumber: "Enter mobile number",
  Email: "Email",
  objectionSummary: "Objection Summary",
  objectionDetails: "Objection Details",
  aadhaar: "Aadhaar Card",
  pan: "PAN Card",
  voter: "Voting Card",
  dl: "Driving License",
  CASE_NO: "Case No.",

  IdentityProof: "Id Proof",
  identityProofType: "Id Proof Type",
  identityProofNumber: "Id Proof No.",
  uploadProof: "Upload Identity Proof",
  affectedArea: "Affected Area",
  village: "Village",
  taluka: "Taluka",

  objectionCategories: "Objection Categories",
  selectCategory: "Select category",
  landAcquisition: "PUNARBHU",
  cropLoss: "Crops Assessment",
  treeLoss: "Trees Assessment",
  measurementIssue: "Measurement Issues",
  assetAssessment: "Structures Assessment",
  treeOwnership: "Tree Ownership Issues",
  others: "Other",
  reset: "Reset",
  waterBodies: "Water Bodies",
  ownershipIssues: "Title/Ownership Issues",
  livelihoodImpact: "Livelihood Impact",
  submissionsuccessful: "Submission Successful!",
  yoh: "Your objection has been submitted successfully",
  referencenumber: "Reference Number",
  submissiondate: "Submission Date",
  pkyr: "Please keep your reference number for future inquiries.",
  sao: "Submit Another Objection",
  pctfe: "Please correct the following errors",
  maxsize: "Max size: 256KB, formats: JPG, PNG, PDF",
  fileuploaded: "File uploaded",
  KB: "KB",
  psalo: "Please select at least one objection category",
  Processing: "Processing...",


  //EditLandTypeMangement
  typeCode: "Type Code",

  //Hearing
  hearingManagement: "Hearing Management",
  scheduleNewHearing: "Schedule New Hearing",
  upcomingHearings: "Upcoming Hearings",
  ongoingHearings: "Ongoing Hearings",
  completedHearings: "Completed Hearings",
  dateOfHearing: "Date of Hearing",
  place: "Place",
  designatedTo: "Designated To",
  searchPlacePlaceholder: "Search Place (Buldhana District)",
  designatedPersonPlaceholder: "Enter the designated person for this case",
  generateNotice: "Generate Notice",
  uploadDocuments: "Upload Documents",
  Share: "Share",
  dateLimitNote: "Cannot be more than 60 days from today",
  caseNumber: "Bhusampadan Number",
  hearingdate: "Hearing Date",
  assignedTo: "Assigned To",
  Decision: "Decision",
  View: "View",
  update: "Update",
  CaseDetails: "Case Details",
  CaseInformation: "Case Information",
  CaseDetails1: "Case Details ",
  CaseIncharge: "Case Incharge :",
  InFavor: "In Favor",
  LandOwners: "Land Owners",
  HearingProgress: "Hearing Progress",
  AttachedDocuments: "Attached Documents",
  ShareDetails: "Share Details",
  Close: "Close",
  UpdateStatus: "Update Status",

  ShareHearingDetails: "Share Hearing Details",
  Enteremailaddress: "Enter email address",
  MobileNumber: "Mobile No.",
  sendnotification: "Send Notification",

  //Landholdinglist
  landholdingDetail: "Proposal Details",
  LandholdingManagement: "Landholding Management",
  AddLandholding: "Add Landholding",
  SearchPlaceholder: "Search by Land No. or Landholder's Name",
  LandholdersName: "LANDHOLDER'S NAME (7/12)",
  Delete: "Delete",

  //LandTypeManagement
  Search: "Search",
  SearchProjects: "Search Projects",
  Add_New_Land_Type: "Add New Land Type",
  All: "All",
  All_Types: "All Types",
  Agricultural: "Agricultural",
  NonAgricultural: "Non-Agricultural",
  Forest: "Forest",
  Government: "Government",
  CODE: "CODE",
  NAME_EN_MR: "NAME (EN/MR)",
  PROPERTIES: "PROPERTIES",
  Agricultural_Land: "Agricultural Land",
  Used_for_farming_and_cultivation: "Used for farming and cultivation.",
  Forest_Land: "Forest Land",
  Protected_forest_area_under_government_control: "Protected forest area under government control.",

  //MeasurementList
  Land_Management_System: "Land Management System",
  Collector_Buldhana: "Collector, Buldhana",
  Administrator: "Administrator",
  Land_Measurement_Records: "Land Measurement Records",
  Search_records: "Search records...",
  No: "No.",
  ACTUAL_AREA_ERC: "ACTUAL AREA E.R.C.",
  ACQUISITION_AREA_ER_PUBLIC: "ACQUISITION AREA E.R. (PUBLIC)",
  OWNER_NAME_AS_PER_RECORD: "OWNER NAME AS PER RECORD",
  GOVERNMENT_AREA_ERC: "GOVERNMENT AREA E.R.C.",
  REVISED_LAND_ACQUISITION: "REVISED LAND ACQUISITION",
  PROJECT_LAND_SURVEY_AREA: "PROJECT LAND SURVEY AREA",

  RECENT_AREA_ER: "RECENT AREA E.R.",
  SURVEY_NOTE_ER: "SURVEY NOTE E.R.",
  SUITABL_AREA_ER: "SUITABL AREA E.R.",
  PROJECT_BENEFICIARY_NAME: "PROJECT BENEFICIARY NAME",
  COMBINED_SURVEY_POINT: "COMBINED SURVEY POINT",

  Pond_Plant: "Pond/Plant",
  House: "House",
  Well_Motor: "Well/Motor",
  Burial_Site: "Burial Site",
  Trees: "Trees",

  None: "None",
  Add_New_Measurement: "Add New Measurement",
  HideForm: "Hide Form",
  cm: "cm",

  Add_New_Measurement_Details: "Add New Measurement Details",
  Actual_Area_ERC: "Actual Area E.R.C.",
  Acquisition_Area: "Acquisition Area",
  Owner_Name: "Owner Occupant",
  Government_Area_as_per_Record: "Government Area as per Record",
  Revised_Land_Acquisition_Area: "Revised Land Acquisition Area",
  Project_Land_Survey_Area: "Project Land Survey Area",
  Survey_Suitable_ER: "Survey Suitable E.R.",
  Note_Area_ER: "Note Area E.R.",
  Beneficiary_Name: "Beneficiary Name",
  Beneficiary_Area: "Beneficiary Area",
  Submit: "Submit",

  //ObjectionList
  ScheduleHearing: "Schedule Hearing",
  Objection_Management_System: "Objection Management System",
  All_Objections: "All Objections",
  General: "General",
  Private: "Private",
  Search_objections: "Search objections...",
  Filter_Status: "Filter Status",
  FilterbyStatus: "Filter by Status",
  Export_Data: "Export Data",
  General_Objection: "General Objection",
  Affected_Person_Objection: "Affected Person Objection",
  Showing_3_of_7_objections: "Showing 3 of 7 objections",
  Clear_all_filters: "Clear all filters",
  Scheduled: "Scheduled",
  OBJECTION_TYPE: "Objection Type",
  OBJECTOR: "Objector",
  Project_B: "Project B",
  Project_D: "Project D",
  AllStatuses: "All Statuses",
  Rejected: "Rejected",
  NOF: "No objections found",
  TAYF: " Try adjusting your filters or create a new objection.",
  Phone: "Phone",

  //PrivateObjection
  AffectedPersonObjection: " Affected Person Objection",
  Submityourprivateobjectiondetails: "Submit your private objection details",
  OwnerInformation: "Owner Information",
  Address: "Address",
  uploadIdentityProof: "Upload Identity Proof",
  Representative: "Representative Details (If applicable)",
  representativeName: "Representative Name",
  relationshipWithOwner: "Relationship with Owner",
  LandDetails: "Land Details",
  accurateLandRecords: "Accurate Land Records",
  assessmentIssue: "Trees Assessment",
  cropsAssessment: "Crops Assessment",
  titleOwnershipIssue: "Title/Ownership Issue",
  nonAgriculture: "Non-Agriculture",
  measurementIssues: "Measurement Issues",
  structureAssessment: "Structure Assessment",
  otherObjection: "Other Objection",

  resetForm: "Reset Form",
  submitObjection: "Submit Objection",

  //ProjectManagement
  projectManagement: "Create/Edit Project",
  newProject: "New Project",
  advancedFilters: "Advanced Filters",
  filterProjects: "Filter Projects",
  dateRange: "Date Range",
  allManagers: "All Managers",
  budgetRange: "Budget Range",
  min: "Min",
  max: "Max",
  applyFilters: "Apply Filters",

  //Reports
  ReportManagementSystem: "Report Management System",
  SelectReportType: "Select Report Type",
  ObjectionReport: "Objection Report",
  LandReport: "Land Report",
  ProjectReport: "Project Report",
  DownloadList: "Download List",
  SearchByNameProjectOrOfficer: "Search by name, project, or officer",
  ProjectStatus: "Project Status",
  HearingStatus: "Hearing Status",
  ObjectorNames: "Objector Names",
  DesignatedOfficer: "Designated Officer",
  ProjectNameOrID: "Project Name/ID",
  ViewDetails: "View Details",
  Resolved: "Resolved",
  Upcoming: "Upcoming",
  AllTypes: "All Types",
  GenerateReport: "Generate Report",
  GenerateDownload: "Generate & Download",

  //VillageManagement
  VillageManagerTitle: "Village Manager – Buldhana, Maharashtra",
  TalukaName: "Taluka Name",
  PinCode: "PIN Code",
  CensusCode: "Census Code",
  Latitude: "Latitude",
  Longitude: "Longitude",
  AddVillage: "Add Village",
  NoVillages: "No villages added",
  Maharastra: "Maharastra",
  Taluka: "Taluka",
  StateCode: "State Code",
  Pin: "Pin",
  Lat: "LAT",
  Long: "LONG",
  Created: "Created",
  Updated: "Updated",

  //UserProfile
  UserProfile: "User Profile",
  EditProfile: "Edit Profile",
  LoadProfileError: "Failed to load profile data. Please try again later.",
  Online: "Online",
  PersonalInformation: "Personal Information",
  FullName: "Full Name",
  Mobile: "Mobile",
  LocationInformation: "Location Information",
  Tehsil: "Tehsil",
  ProfessionalInformation: "Professional Information",
  Designation: "Designation",
  Department: "Department",

  //EditLandTypeManagement
  EditLandType: "Edit Land Type",
  TypeCode: "Type Code",
  NameEnglish: "Name (English)",
  NameMarathi: "Name (Marathi)",
  DescriptionEnglish: "Description (English)",
  DescriptionMarathi: "Description (Marathi)",
  LegalReference: "Legal Reference",
  DisplayOrder: "Display Order",
  ClassificationLevel: "Classification Level",
  ActiveStatus: "Active Status",
  LandClassification: "Land Classification",
  AssessmentType: "Assessment Type",
  RevenueCategory: "Revenue Category",
  DevelopmentPotential: "Development Potential",
  TransferRestrictions: "Transfer Restrictions",
  LandRateMultiplier: "Land Rate Multiplier",
  IrrigationType: "Cultivable Type",
  CropPattern: "Crop Pattern",
  AgriculturalLand: "Agricultural Land",
  NonAgriculturalLand: "Non-Agricultural Land",
  ForestLand: "Forest Land",
  ForestCategory: "Forest Category",
  GovernmentLand: "Government Land",
  GovernmentDepartment: "Government Department",
  GovernmentPurpose: "Government Purpose",
  AdditionalProperties: "Additional Properties",
  GaothanArea: "Gaothan Area",
  WaterBody: "Water Body",
  SpecialEconomicZone: "Special Economic Zone",
  TribalArea: "Tribal Area",
  CoastalZone: "Coastal Regulation Zone",
  HeritageSite: "Heritage Site",
  CeilingApplicable: "Ceiling Applicable",
  TenancyApplicable: "Tenancy Applicable",
  landtype: "Land Type",
  SelectType: "Select Type",
  Regular: "Regular",
  Exempt: "Exempt",
  Special: "Special",
  SelectPotential: "Select Potential",
  High: "High",
  medium: "Medium",
  Low: "Low",
  Canal: "Canal",
  Well: "Well",
  TubeWell: "Tube Well",
  Rainfed: "Rainfed",
  SelectPattern: "Select Pattern",
  Seasonal: "Seasonal",
  Annual: "Annual",
  Perennial: "Perennial",
  Purpose: "Purpose",
  Protected: "Protected",
  Reserved: "Reserved",
  WaterBodyType: "Water Body Type",
  River: "River",
  Lake: "Lake",
  Pond: "Pond",
  Reservoir: "Reservoir",

  //RoleManagement
  searchUsers: "Search users or projects...",
  addUser: "Add User",

  username: "USERNAME",
  mobileNo: "MOBILE NO.",
  Role: "Role",
  noUsers: "No users available",
  addUserPrompt: "Add a new user to get started",
  Nousersfound: "No matching users found",
  Tryfilter: "Try adjusting your search term or clear the filter",
  showingUsers: "Showing {count} of {total} users",

  title: "Assign User Role",
  searchUsername: "Search Username",
  selectRole: "Select Role",
  edituserrole: "Edit User Role",
  selectproject: "Select Project",
  selectproposal: "Select Proposal",
  ConfirmDeletion: "Confirm Deletion",
  aysy: "Are you sure you want to delete this user? This action cannot be undone.",

  //Dashboard
  ProjectManagement: "Project Management",
  LandholdingList: "Landholding List",
  AddLandholdingList: "Add Landholding List",
  EditLandholdingList: "Edit Landholding List",
  VillageManagement: "Village Management",
  PrivateObjection: "Private Objection",
  MeasurementViseObjectionForm: "Measurement Vise Objection Form",
  MeasurementList: "Measurement List",
  AcquisitionRecords: "Acquisition Records",
  Reports: "Reports",
  Section19: "Section 19",
  Section23: "Section 23",
  CoveringLetters: "Land Acquisition Officer Appointment",
  CoveringLettersSection11: "Section 11 Covering Letter",
  CoveringLettersSection19: "Section 19 Covering Letter",
  CoveringLettersSection15: "Section 15 Covering Letter",

  //UserManagement
  Error: "Error",
  tryagain: "Try Again",
  adminusermanagement: "Admin User Management",
  addnewuser: "Add New User",
  maml: "Manage all admin-level users, their roles, login credentials, and access statuses.",
  DeleteSelected: "Delete Selected",
  name: "Name",
  enterfullname: "Enter full name",
  Password: "Password",
  ConPassword: "Conform Password",
  workAssign: "Work Assign",
  Requiredfields: "Required fields",
  EditUser: "Edit User",
  UpdateUser: "Update User",
  ConfirmDelete: "Confirm Delete",
  aysyw: "Are you sure you want to delete the user ",
  tacbu: "? This action cannot be undone.",

  // SubUserManagement
  subUserLoader: "Sub-user is loading...",
  work: "Work",
  addSubUser: "Add Sub-user",
  editSubUser: "Edit Sub-user",
  noWorkAssignmentsAvailable: "No work assignments available",
  enterPassword: "Enter password",
  enterConfirmPassword: "Enter confirm password",

  //About
  GovernmentOfMaharashtra: "Government of Maharashtra",
  Home: "Home",
  Home1: "Home",
  About: "About",
  Economy: "Economy",
  Administration: "Administration",
  Gallery: "Gallery",
  Contact: "Contact",

  AboutBuldhana: "About Buldhana District",
  BuldhanaTagline: "Heart of Maharashtra, Rich in Culture and Heritage",
  Explore: "Explore",

  //District Overview
  DistrictOverview: "District Overview",
  Buldhanapara: "Buldhana is a district in the Amravati division of Maharashtra state in western India. Located in the western Vidarbha region, it is known for its agricultural prosperity, historical significance, and the world-famous Lonar Crater Lake - a notified National Geo-heritage Monument.",
  Population: "Population",
  ldes: "Vidarbha Region, Eastern Maharashtra",
  ades: "9,661 sq km,",
  pdes: "Approx. 2.5 million",
  hdes: "Buldhana City",
  map: "Geographical map of Buldhana District",

  //Geography & Climate
  GeographyClimate: "Geography & Climate",
  LandscapeTopography: "Landscape & Topography",
  ltp1: "Buldhana district features varied topography with the Satpura Range in the north and plains in the south. The district is situated on the Deccan Plateau with elevations ranging from 400 to 800 meters above sea level.",
  ltp2: "The most notable geological feature is the Lonar Crater Lake, formed by a meteor impact approximately 52,000 years ago. It is the third-largest natural salt-water lake in the world and the only known hyper-velocity impact crater in basaltic rock.",
  ltp3: "The district is drained by the Purna River and its tributaries, which are part of the Tapi River system, providing essential water resources for agriculture.",
  ClimateCharacteristics: "Climate Characteristics",
  Rainfall: "Rainfall",
  Summer: "Summer (March–June)",
  Winter: "Winter (November–February)",
  Monsoon: "Monsoon (June–September)",
  rd: "Average annual rainfall: 700-900 mm, primarily during monsoon (June-September)",
  sd: "Hot and dry with temperatures ranging from 30°C to 45°C",
  wd: "Mild and pleasant with temperatures ranging from 10°C to 25°C",
  md: "Moderate rainfall distributed across the district",

  //Culture & Festivals
  CultureFestivals: "Culture & Festivals",
  ReligiousFestivals: "Religious Festivals",
  FolkArtMusic: "Folk Art & Music",
  Cuisine: "Cuisine",
  ReligiousFestivalspara: "Ganesh Chaturthi, Diwali, and Navratri are celebrated with great enthusiasm. The district is known for its vibrant processions and community gatherings during these festivals.",
  FolkArtMusicpara: "Traditional Marathi folk dances like Lavani and Koli are popular in the region. Local music forms a crucial part of cultural identity with instruments like Dholki and Tabla.",
  Cuisinepara: "The district is known for its spicy Maharashtrian cuisine with specialties like Vada Pav, Puran Poli, and various Koshimbirs (salads). Local sweets like Basundi and Jalebi are popular during festivals.",

  //Economy & Livelihood
  EconomyLivelihood: "Economy & Livelihood",
  Cotton: "Cotton (a major cash crop)",
  Soybeans: "Soybeans",
  Pulses: "Pulses (Tur, Moong, Urad)",
  JowarWheat: "Jowar and Wheat",
  Fruits: "Fruits like oranges and sweet limes",
  IndustryServices: "Industry & Services",
  CottonGinning: "Cotton ginning and pressing units",
  AgroProcessing: "Agricultural processing industries",
  SmallScaleIndustries: "Small-scale industries in Khamgaon, Malkapur, and Buldhana city",
  HandicraftsHandloom: "Handicrafts and handloom sectors",
  ELP1: "Agriculture forms the backbone of Buldhana's economy, with around 70% of the population dependent on it. The district is known for its production of:",
  ELP2: "The district has implemented various Cultivable projects to boost agricultural productivity, including the Purna and Upper Wardha Cultivable projects.",
  ELP3: "While primarily agricultural, Buldhana is gradually developing its industrial sector:",
  ELP4: "The service sector is growing, primarily in urban areas, with banking, education, healthcare, and government services providing significant employment opportunities. Tourism centered around the Lonar Crater Lake and religious sites is an emerging sector.",

  //Administrative Setup
  AdministrativeSetup: "Administrative Setup",
  DistrictAdministration: "District Administration",
  DistrictCollectorate: "District Collectorate",
  ZillaParishad: "Zilla Parishad",
  MunicipalCouncils: "Municipal Councils",
  AdministrativeDivisions: "Administrative Divisions",
  Buldhana: "Buldhana",
  Chikhli: "Chikhli",
  DeulgaonRaja: "Deulgaon Raja",
  JalgaonJamod: "Jalgaon Jamod",
  Malkapur: "Malkapur",
  Mehkar: "Mehkar",
  Motala: "Motala",
  Nandura: "Nandura",
  Sangrampur: "Sangrampur",
  Shegaon: "Shegaon",
  SindkhedRaja: "Sindkhed Raja",
  Khamgaon: "Khamgaon",
  Lonar: "Lonar",
  ASP1: "The district is administered by the District Collector (IAS Officer) who oversees various departments and ensures implementation of government policies and programs.",
  ASP2: "Located in Buldhana city, it serves as the administrative headquarters",
  ASP3: "Manages development activities in rural areas",
  ASP4: "Manage urban areas like Buldhana, Khamgaon, Malkapur, Shegaon, etc.",
  ASP5: "Buldhana district is divided into 13 tehsils (administrative divisions) for efficient governance and administration:",

  //District Gallery
  DistrictGallery: "District Gallery",
  LonarCraterLake: "Lonar Crater Lake",
  ShegaonTemple: "Shegaon Temple",
  SindkhedRajaFort: "Sindkhed Raja Fort",
  BuldhanaCity: "Buldhana City",

  //HomePage
  Login: "Login",
  Overview: "Overview",
  Notifications: "Notifications",
  ViewNivada: "View Nivada",

  Pause: "Pause",
  Play: "Play",
  LiveData: "Live Data",
  RealTimeUpdates: "Real-time Updates",
  LocationNotSpecified: "Location not specified",
  ClickToViewDetails: "Click to view details",
  BuldhanaLand: "Buldhana Land",
  AcquisitionPortal: " Acquisition Portal",
  AcquisitionTagline: "Transparent and efficient land acquisition process for development projects throughout Buldhana district",

  BuldhanaGlance: "Buldhana District at a Glance",
  GlanceTagline: "An overview of our vibrant district and its key statistics",
  BuldhanaOverview: "Buldhana District Overview",
  DevelopingHub: "Maharashtra's Developing Hub",

  KeyHighlights: "Key Highlights",
  ActiveProjects: "Active Projects",
  GrowthTagline: "Driving regional growth and development",
  GeoHeritage: "National geo-heritage monument",

  AgriculturalHub: "Agricultural Hub",
  VidarbhaProducer: "Major producer in Vidarbha region",

  EducationalGrowth: "Educational Growth",
  NewUniversities: "New universities and institutes emerging",

  ImprovedConnectivity: "Improved Connectivity",
  ConnectivityUpgrades: "Major highway and rail infrastructure upgrades",

  CulturalDiversity: "Cultural Diversity",
  HeritageTagline: "Festivals and traditions showcasing rich heritage",

  DistrictFacts: "District Facts",
  AreaValue: "9,661 sq km",
  PopulationValue: "2.6 million",
  Headquarters: "Headquarters",
  HeadquartersValue: "Buldhana City",
  Established: "Established",
  EstablishedValue: "1905",
  Subdivisions: "Subdivisions",
  SubdivisionsValue: "13 talukas",

  Infrastructure: "Infrastructure",
  RoadNetwork: "Road Network",
  RoadValue: "3,200 km of roads across the district",
  IrrigationProjects: "Irrigation Projects",
  IrrigationValue: "15 major irrigation projects in progress",
  EducationFacilities: "Education Facilities",
  EducationValue: "1,200+ schools and 25 colleges",
  HealthcareCenters: "Healthcare Centers",
  HealthcareValue: "68 hospitals and health centers",

  WantToLearn: "Want to learn more about Buldhana's development initiatives?",
  ExploreDistrict: "Explore our comprehensive district profile and ongoing projects.",
  ExploreProfile: "Explore District Profile",
  DevelopmentProjects: "Development Projects",
  ViewAllProjects: "View All Projects",
  ProjectOverviewStats: "Project Overview Statistics",
  AboutDistrict: "About Buldhana District",
  Aboutdes1: "Buldhana district is located in the Vidarbha region of Maharashtra state in India. The district is known for its agricultural productivity and is home to several development projects aimed at improving infrastructure and economic growth.",
  Aboutdes2: "The Land Acquisition department ensures fair compensation and transparent processes for all land acquisitions required for public projects like roads, dams, and industrial zones.",

  TotalProjects: "Total Projects",
  Categories: "Categories",
  BuldhanaCollector: "Collector Office Buldhana",
  LearnMore: "Learn More",
  DevelopmentTitle: "Buldhana District Development",
  DevelopmentDesc: "Focused initiatives and projects transforming Buldhana district",
  AtAGlance: "At a Glance",
  DevelopmentFocus: "Development Focus",
  ProgressOverview: "Progress Overview",

  DistrictIntro: "Buldhana district spans 9,661 sq km in western Vidarbha with a population of approximately 2.5 million across 13 talukas.",
  DevelopmentFocus1: "Prioritizing agricultural infrastructure, water resources, road connectivity, and sustainable rural development.",
  OngoingProjects: "Currently executing major projects with comprehensive development across infrastructure and agriculture sectors.",
  ContactUs: "Contact Us",
  ContactInfo: "Get in touch with our team for any questions or assistance",
  Addressbuldhana: "Office Address",
  OfficeAddress: "Collector Office, Buldhana, Maharashtra - 443001",
  PhoneContact: "Phone Contact",
  EmailSupport: "Email Support",
  CurrentlyManaging: "Currently managing",
  ActiveProjectsInDistrict: "active projects across Buldhana district",
  ShowingActiveProjects: "Showing active projects",
  PreliminarySurvey: "Preliminary survey",
  NotificationIssued: "Notification issued",
  LandSurveyCompleted: "Land survey completed",
  LandMarkingProgress: "Land marking in progress",
  CompensationFinalized: "Compensation finalized",
  AllStatus: "All Status",
  InactiveProjects: "Inactive Projects",
  LandMarkingInProgress: "Land marking in progress",
  SiteInspectionCompleted: "Site inspection completed",
  CompensationProcessing: "Compensation processing",
  FinalAssessment: "Final assessment",
  ShowingOfTotal: "Showing",
  TProjects: "total projects",
  ClearAll: "Clear All",
  NoProjectsFound: "No projects found",
  TryAdjusting: "Try adjusting your search or filter to find what you're looking for",
  ClearAllFilters: "Clear All Filters",
  BhudharakArea: "Bhudharak Area",
  Started: "Started",
  Complete: "Complete",
  ProjectInformation: "Project Information",
  SelectProposal: "Select Proposal",
  RoadInfraNote: "Road Infrastructure project in State Government/Union Territories division. Land acquisition number: N/A",
  People: "PEOPLE",
  PleaseWait: "Please wait",
  ProjectArea: "Project Area",
  CurrentStatus: "Current Status",
  Division: "Division",
  LastUpdated: "Last Updated",
  BudharakCount: "Budharak Count",
  Description1: "Description",
  AdministrativeDetails: "Administrative Details",
  LandAcquisitionNo: "Land Acquisition No",
  AdministrativeOrderNo: "Administrative Order No",
  RaiseObjection: "Raise Objection",
  LastDateWarning: "The date to raise objection has surpassed (Deadline:",
  SelectOwner: "Select Owner",
  OwnerWarning: "Enter Gat No to load owners",
  uploadDocumentss: "Upload Document",
  field: "Field",
  value: "Value",
  SelectedProposal: "Selected Proposal",

  PortalTitle: "Official Land Acquisition and Management Portal for Buldhana District, Maharashtra",
  QuickLinks: "Quick Links",
  ImportantResources: "Important Resources",
  MaharashtraGovernment: "Maharashtra Government",
  Sahajpranali: "Sahajpranali",
  Jigaon: "Jigaon",
  AmravatiDivision: "Amravati Division",
  AapleSarkar: "Aaplesarkar",
  OfficeHours: "Office Hours",
  MondaytoFriday: "Monday to Friday",
  Saturday: "Saturday",

  //login
  SignIn: "Sign In",
  AdminSignIn: "Admin Sign In",
  EnterCredentials: "Please enter your credentials below",
  EmailOrMobile: "Email or Mobile Number",
  ForgotPassword: "Forgot password?",
  SignInButton: "Sign In",
  SwitchToAdmin: "Switch to Admin Sign In",
  SwitchtoUserSignIn: "Switch to User Sign In",
  NoAccount: "Don't have an account?",
  OR: "OR",
  SigningIn: "Signing In",

  SignUp: "Sign Up",
  CreateAccount: "Create an Account",
  JoinPlatform: "Join our platform today",
  FirstName: "First Name",
  LastName: "Last Name",
  ConfirmPassword: "Confirm Password",
  TermsAgreement: "I agree to the Terms of Service and Privacy Policy",
  CreateAccountButton: "Create Account",
  AlreadyHaveAccount: "Already have an account?",

  //ForgotPassword
  BackToSignIn: "Back to Sign In",
  DontWorry: "Don't worry, we'll help you reset your password",
  SendCodeInfo: "We'll send a verification code to your email address to reset your password",
  SendVerificationCode: "Send Verification Code",
  VerifyCode: "Verify Code",
  EnterCodePrompt: "Enter the 6-digit verification code sent to",
  VerificationCode: "Verification Code",
  Resending: "Resending",
  DidntReceiveCode: "Didn't receive a code? Resend",
  Verifying: "Verifying...",
  VerifyAndContinue: "Verify & Continue",
  ResetPassword: "Reset Password",
  NewPasswordPrompt: "Create a new password for your account",
  NewPassword: "New Password",
  Resetting: "Resetting",


  //AreaUnitManagement
  AreaUnitManagement: "Area Unit Management",

  loadingAreaUnits: "Loading area units...",
  error: "Error",
  addNewAreaUnit: "Add New Area Unit",
  sNo: "S.NO.",
  unitName: "Unit Name",
  unitCode: "Unit Code",
  conversionToSqm: "Conversion to sqm",
  noAreaUnitsFoundMatching: "No area units found matching your criteria",
  entries: "entries",
  noAreaUnitsFound: "No area units found. Click \"Add Area Unit\" to get started",
  Sau: "Search area units...",
  AddArea: "Add New Area Unit",
  EditAre: "​Edit Area Unit",


  //ConcernValuer
  filterChange: "Filter & Change",
  changeConcernValuer: "Change Concern Valuer",
  sendToLAO: "Send to LAO",
  selectedRecords: "Selected",
  ownerDetails: "Owner Details",
  landRate: "Land Rate",
  landAmount: "Land Amount (₹)",
  treeDetails: "Tree Details",
  cropDetails: "Crop Details",
  totalCompensation: "Total Compensation",
  unknownOwner: "Unknown Owner",
  na: "N/A",
  count: "Count",
  showingRecords: "Showing {{count}} records",

  SelectAgencyType: "Select Agency Type",
  ChooseAgency: "Choose your agency to access relevant compensation management",
  ContinueToCompensation: "Continue to Compensation Management",
  WhatNext: "What you'll see next",
  LoadingData: "Loading data...",
  PleaseSelectDistrict: "Please select at least a District to view compensation data. You can optionally select Taluka and Village to further filter the results.",
  SendBackToLAO: "Send Back to LAO",
  SelectLAOUser: "Land Acq. Officer",
  SelectSamanvayOfficer: "Select Samanvay Officer",
  Structure: "Structure",
  Borewell: "Borewell",
  Pipeline: "Pipeline",
  TinShed: "TinShed",
  Wire: "Wire",
  OtherAsset: "Other Asset",
  Total: "Total",
  LoadingCompensationRecords: "Loading compensation records...",
  location: "Location",
  Records: "Records",
  PleaseSelectAtLeastDistrict: "Please select at least a District from the filter panel above to view compensation data. You can optionally select Taluka and Village to further filter the results.",
  AgencySelected: "Agency Selected",
  ChangeConcernValuer: "Change Concern Valuer",
  LoadingOfficers: "Loading Officers...",
  SelectOfficer: "Select Officer",
  LandAmount: "Land Amount",
  Details: "Details",
  Tree: "Tree",
  Crop: "Crop",
  YouAreAboutToProceed: "You are about to proceed",
  DoYouReallyWantToContinuePendingSurveys: "Do you really want to continue? There are still some surveys left to be verified.",
  YesContinue: "Yes, Continue",
  consulting_agent: "Consulting Agent",
  VillageCouncil: "Village Council",
  TreeAndCropCompensationManagementInterfaceWithRelevantFieldsOnly: "Tree and Crop compensation management interface with relevant fields only.",
  TreeCompensationManagementInterfaceFocusedOnForestryAssets: "Tree compensation management interface focused on forestry assets",
  InfrastructureAndAssetCompensationInterfaceForConsultingWork: "Infrastructure and asset compensation interface for consulting work",
  CompleteCompensationManagementInterfaceWithAllAvailableCategories: "Complete compensation management interface with all available categories",
  Aga: "Actual",
  Aghome: "Home (area)",
  Agpipeline: "Pipeline (length)",
  Agborewell: "Borewell (length)",
  Agarea: "Area",
  Areacalculation:"According to JMR",
  Areaaccordingtocombinedcalculation: "Area according to combined calculation",
  Agactualarea: "Actual area",
  Lengthaccordingtojointmeasurement: "Length according to joint measurement",
  actuallength: "Actual length",
  Agmeter: "meter",
  Agsquaremeter: "square meter",
  Yearofexcavation: "Year of excavation",
  NewOtherAsset: "Other construction",
  lengthheight: "length * height",
  actualDepth: "Actual Depth",
  //CreateMeasurment
  createNewMeasurement: "Create New Measurement",
  measurementCreated: "Measurement created successfully! Form will close automatically.",
  landAcquisitionId: "Land Acq. ID",
  ownerType: "Owner Type",
  individual: "Individual",
  corporate: "Corporate",
  identityInformation: "Id Information",
  aadhaarNumber: "Aadhaar No.",
  idProofType: "ID Proof Type",
  idProofNumber: "ID Proof No.",
  bankInformation: "Bank Information",
  bankName: "Bank Name",
  branchName: "Branch Name",
  accountNumber: "Account Number",
  ifscCode: "IFSC Code",
  accountHolderName: "Account Holder Name",
  landInformation: "Land Information",
  SurveyNumber: "Survey No.",
  TotalArea_7_12:"Total Area",
  talukaName: "Taluka Name",
  areaUnit : "Area Unit",
  areaUnitId: "Area Unit ID",
  landTypeId: "Land Type ID",
  titleType: "Title Type",
  landCategory: "Land Category",
  landUse: "Land Use",
  ownershipPercentage: "Ownership Percentage",
  valuationInformation: "Valuation Information",
  landValueRate: "Land Value Rate",
  totalLandValue: "Total Land Value",
  structureValue: "Structure Value",
  treeValue: "Tree Value",
  cropValue: "Crop Value",
  waterBodyValue: "WaterBody Value",
  otherAssetValue: "OtherAsset Value",
  solatiumPercentage: "Solatium Percentage",
  solatiumAmount: "Solatium Amount",
  hasObjection: "Has Objection",
  objectionId: "Objection ID",
  documentInformation: "Document Information",
  acquisitionDate: "Acquisition Date",
  documentNumber: "Document Number",
  registrationDate: "Registration Date",
  mutationNumber: "Mutation Number",
  awardNumber: "Award Number",
  awardDate: "Award Date",
  documentReferences: "Document References",

  //DirectPayment
  DirectPurchaseInfo: "Edit Proposal Direct Purchase Info",
  AddDirectPurchaseRecord: "Add  Purchase/Sales Record",
  ClearFilters: "Clear Filters",
  District: "District",
  LoadingDirectPurchaseRecords: "Loading direct purchase records...",
  NoDirectPurchaseRecordsFound: "No direct purchase records found",
  BeneficiaryName: "Beneficiary Name",
  PurchaseDate: "Purchase Date *",
  Farmer: "Farmer",
  Organization: "Organization",
  IDProofInformation: "ID Proof Information",
  IDProofType: "ID Proof Type",
  AadhaarCard: "Aadhaar Card",
  PANCard: "PAN Card",
  VoterID: "Voter ID",
  DrivingLicense: "Driving License",
  Passport: "Passport",
  IDProofNumber: "ID Proof No.",
  PANNumber: "PAN No.",
  LandType: "Land Type",
  SelectLandType: "Select Land Type",
  Residential: "Residential",
  Commercial: "Commercial",
  Industrial: "Industrial",
  RegistrationDate: "Registration Date",
  MutationNumber: "Mutation Number",
  LandValueRate: "Land Value Rate (per unit)",
  TotalLandValue: "Total Land Value",
  AdditionalInformation: "Additional Information",
  DocumentReferences: "Document References",
  ChooseFile: "Choose File",
  AcceptedFormats: "Accepted formats: PDF, DOC, DOCX, JPG, JPEG, PNG (Max 10MB)",
  AddDirectPurchase: "Add Direct Purchase",
  EditDirectPurchase: "Edit Direct Purchase",

  //AddOwner
  Valid: "Valid",
  DocumentStatus: "Document Status:",
  FileName: "File Name",
  FileSize: "File Size",
  Replace: "Replace",
  Upload: "Upload",
  AddNewPropertyOccupant: "Add New Property Occupant",
  CompleteallsectionstoaddtheOccupantsuccessfully: "Complete all sections to add the Occupant successfully",
  OccupantInformation: "Occupant Information",
  BasicdetailsaboutthepropertyOccupant: "Basic details about the property Occupant",
  OccupantName: "Occupant Name",
  OccupantType: "Occupant Type",
  SelectOccupanttype: "Select Occupant type",
  JointOccupant: "Joint Occupant",
  CompanyCorporation: "Company/Corporation",
  EmailAddress: "Email ID",
  CompleteAddress: "Complete Address",
  IdentityDocuments: "Identity Documents",
  AadhaarNumberDocument: "Aadhaar Number Document",
  PANNumberDocument: "PAN Number Document",
  OccupantPortionDocument: "Occupant Portion Document",
  LocationInformationMedia: "Location Information & Media",
  Geographiccoordinateslocationdetailsandpropertymediafiles: "Geographic coordinates, location details, and property media files",
  GPSCoordinates: "GPS Coordinates",
  GettingLocation: "Getting Location...",
  GetLocation: "Get Location",
  ViewonMap: "View on Map",
  PropertyMediaFiles: "Property Media Files",
  Uploadimagesandvideosofthepropertyfordocumentationandverification: "Upload images and videos of the property for documentation and verification",
  Landownershipandcompensationdetails: "Land ownership and compensation details",
  Acquired: "Acquired",
  Required: "Required",
  TotalOccupantLandPortion: "Total Land Portion",
  OccupandLandAcquisitionValue: "Required Land Portion",
  MustbeLessThanEqualTotalOccupantLandPortion: "Must be ≤ Total Land Portion",
  Autocalculated: "Auto-calculated:Total Land Portion ÷ Acquisition Value × 100",
  MixedUse: "Mixed Use",
  CurrentLandUse: "Current Land Use",
  Selectlanduse: "Select land use",
  Farming: "Farming",
  VacantLand: "Vacant Land",
  ResidentialBuilding: "Residential Building",
  Warehouse: "Warehouse",
  AdditionalPropertyAssets: "Additional Property Assets",
  NoofTree: "No of Tree",
  NoofHome: "No of Home",
  NoofTinShedGodown: "No of Tin Shed/Godown",
  NoofWellShevLake: "No of Well Shev Lake",
  NoofBoreWell: "No of BoreWell",
  NoofPipeline: "No of Pipeline",
  NoofWireFence: "No of Wire Fence",
  File: "File",
  Size: "Size",
  documentStatus: "Document Status",
  fileName: "File Name",
  fileSize: "File Size",
  addNewPropertyOccupant: "Add New Property Occupant",
  completeSectionsToAddOccupant: "Complete all sections to add the Occupant successfully",
  locationAndMedia: "Location & Media",
  propertyDetails: "Property Details",
  basicDetailsAboutOccupant: "Basic details about the property Occupant",
  selectOccupantType: "Select Occupant type",
  jointOccupant: "Joint Occupant",
  companyCorporation: "Company/Corporation",
  completeAddress: "Complete Address",
  enterCompleteAddress: "Enter complete address with postal code",
  punchnamaDocuments: "Punchnama Documents",
  geoCoordinates: "Geographic coordinates, location details, and property media files",
  gpsCoordinates: "GPS Coordinates",
  gettingLocation: "Getting Location...",
  getLocation: "Get Location",
  viewOnMap: "View on Map",
  punchnama: "Punchnama",
  punchnamaPropertyImage: "Panchnama Property Image",
  punchnamaPropertyVideo: "Panchnama Property Video",
  landOwnershipDetails: "Land ownership and compensation details",
  required: "Remaining",
  totalOccupantLandPortion: "Total Land Portion",
  mustBeLessEqualTotalArea: "Must be ≤ Total Land Area",
  mustBeLessEqualOccupantArea: "Must be ≤ Total Occupant Land Portion",
  autoCalculatedTotalPortion: "Auto-calculated: Total Land Portion ÷ Acquisition Value × 100",
  autoCalculatedOrManual: "Auto-calculated or enter manually",
  mixedUse: "Mixed Use",
  currentLandUse: "Current Land Use",
  selectLandUse: "Select land use",
  farming: "Farming",
  vacantLand: "Vacant Land",
  residentialBuilding: "Residential Building",
  commercialBuilding: "Commercial Building",
  warehouse: "Warehouse",
  additionalAssets: "Additional Assets",
  enterNumber: "Enter number",
  enterNoOfHouses: "Enter no of Houses",
  noOfPipeline: "No of Pipeline",
  noOfTinShed: "No of Tin Shed/Godown",
  noOfWellShevLake: "No of Well Shev Lake",

  //EditProject
  Loadingdocument: "Loading document...",
  Previewnotavailable: "Preview not available",
  ThisdocumentcannotbepreviewedinthebrowserYoucandownloadittoview: "This document cannot be previewed in the browser. You can download it to view.",
  Success: "Success!",
  Projectupdatedsuccessfully: "Project updated successfully",
  CurrentStage: "Executive Engineer Name",
  Thisfieldisnoteditable: "This field is not editable",
  ProjectInchargeName: "Project Incharge Name",
  Projectisactive: "Project is active",
  ProjectBanner: "Project Banner",
  UploadProjectBanner: "Upload Project Banner",
  Supportedformats: "Supported formats: JPG, PNG, GIF. Max size: 5MB",
  TotalLandParcel: "Total Land Parcel",
  NumberofLandOwner: "Number of LandOwner",
  Enteracquisitionnumber: "Enter acquisition number",
  Enternumber: "Enter number",
  UpdateProject: "Update Project",
  PressESCToClose: "Press ESC to close",

  //EditProposal
  Print: "Print",
  UploadSignature: "Upload Signature",
  UpdateProposal: "Update Proposal",
  DepartmentInformation: "Department Information",
  AcquisitionAgency: "Acquisition Agency",
  AcquisitionPurpose: "Acquisition Purpose",
  Descriptions: "Descriptions",
  ProposalDescription: "Proposal Description",
  SocialImpact: "Social Impact",
  SocialBenefit: "Social Benefit",
  DisplacementReason: "Displacement Reason",
  ExemptionInformation: "Exemption Information",
  IsExemptionApplicable: "Is Exemption Applicable?",
  SelectOption: "Select Option",
  Yes: "Yes",
  ExemptionType: "Exemption Type",
  SocialEnvironmentImpactSurvey: "Social Environment Impact Survey",
  GovernmentAuthority: "Government Authority",
  IrrigationProject: "Irrigation Project",
  ExemptionNotificationNumber: "Exemption Notification Number",
  UploadExemptionFile: "Upload Exemption File",
  PDForImagefilesonly: "(PDF or Image files only)",
  Currentfile: "Current file",
  Uploadanewfiletoreplacethecurrentone: "Upload a new file to replace the current one",
  Newfileselected: "New file selected",
  UpdateProposalBtn: "Update Proposal",
  EditProposal: "Edit Proposal",


  //Hearing
  completedHearing: "Completed Hearing",
  loadingHearingData: "Loading hearing data...",
  noObjectionSelected: "No Objection Selected",
  selectObjectionFirst: "Please select an objection first to manage hearings.",
  hearingScheduledSuccess: "Hearing Scheduled Successfully!",
  hearingScheduledMessage: "Your hearing has been scheduled and notifications will be sent.",
  objectionType: "Objection Type",
  objectionRaisedDate: "Objection Raised Date",
  hearingDetails: "Hearing Details",
  hearingStatus: "Hearing Status",
  selectStatus: "Select Status",
  statusScheduled: "Scheduled",
  statusCompleted: "Completed",
  dateWithin60Days: "Date must be within 60 days",
  hearingTime: "Hearing Time",
  hearingLocation: "Hearing Location",
  enterHearingLocation: "Enter hearing location",
  officerInformation: "Officer Information",
  officerName: "Officer Name",
  enterOfficerName: "Enter officer name",
  officerDesignation: "Officer Designation",
  enterOfficerDesignation: "Enter officer designation",
  caseDetails: "Case Details",
  finalDecision: "Final Decision",
  finalVerdictRequiredMessage: "Final Verdict document is required when completing a hearing",
  documentUpload: "Document Upload",
  finalVerdictRequired: "Final Verdict Required",
  clickToUpload: "Click to upload",
  maxFileSize: "Maximum file size: 10MB per file",
  uploadedDocuments: "Uploaded Documents",
  finalVerdict: "Final Verdict",
  uploadingDocuments: "Uploading documents...",
  documentsUploadedSuccess: "All documents uploaded successfully",
  submitting: "Submitting...",
  scheduling: "Scheduling...",
  scheduleHearing: "Schedule Hearing",
  hearingNotice: "Hearing Notice",
  printNotice: "Print Notice",
  uploadFinalVerdictPDF: "Upload Final Verdict (PDF)",
  uploadHearingNoticePDF: "Upload Hearing Notice (PDF)",
  objectionCaseDetails: "Objection Case Details",
  objectorInformation: "Objector Information",
  hearingStatusManagement: "Hearing Status Management",
  hearingDate: "Hearing Date",
  objectionHearingProgress: "Objection Hearing Progress",
  resolvedOn: "Resolved on",
  attachedDocuments: "Attached Documents",
  noDocumentsAttached: "No documents attached to this hearing",
  uploadAdditionalDocuments: "Upload Additional Documents",
  recentlyUploadedDocuments: "Recently Uploaded Documents",
  shareDetails: "Share Details",
  completedHearingDetails: "Completed Hearing Details",
  caseInformation: "Case Information",
  hearingHistory: "Hearing History",
  hearingOutcome: "Hearing Outcome",
  finalVerdictDocument: "Final Verdict Document",
  officialDocument: "OFFICIAL DOCUMENT",
  finalVerdictPending: "Final verdict pending documentation",
  caseDocuments: "Case Documents",
  finalVerdictLabel: "FINAL VERDICT",


  //LandHoldingList
  report: "Report",
  appendix1: "Appendix 1",
  appendix2: "Appendix 2",
  appendix3: "Appendix 3",
  appendix6: "Appendix 6", 
  selectAllToViewLandholding: "Please select District, Taluka, and Village to view landholding data.",
  loadingAllLandholding: "Loading all landholding data...",
  loadingLandholding: "Loading landholding data...",
  tryAdjustingSearch: "Try adjusting your search criteria to find more results.",
  results: "results",
  selectAllToViewData: "Please select District, Taluka, and Village to view data",

  //LandTypeManagement
  AddNewLandType: "Add New Land Type",
  LoadingLandTypes: "Loading land types...",
  NoLandTypesFound: "No land types found matching your criteria.",
  Entries: "entries",

  //MeasurementList
  NoMeasurements: "No Measurements",
  SendVerifiedToLAOOfficer: "Send Verified to LAO Officer",
  ReassignToSurveyor: "Re-assign to Surveyor",
  ReassignConfirmation: "You have already assigned measurements to a surveyor before. Are you sure you want to assign measurements to surveyor again?",
  YesReassign: "Yes, Re-assign",
  SelectDistrictNote: "Please select at least a District to view measurement data. You can optionally select Taluka and Village for more specific filtering.",
  ShowingAllMeasurements: "Showing all measurement records across all locations for this project.",
  LandHolderName: "LandHolder Name As per 7/12",
  AquiredArea: "Aquired Area",
  Verification: "Verification",
  AddDetails: "Add Details",
  LoadingMeasurements: "Loading measurements...",
  AwaitingSurveyorCompletion: "Awaiting Surveyor Completion",
  Verify: "Verify",
  Verified: "Verified",
  AddEdit: "Add/Edit",
  NoMeasurementData: "No measurement data found for selected filters",
  DistrictSelectionRequired: "District Selection Required",
  DistrictSelectionNote: "Please select at least a District from the filter panel above to view measurement data.",
  SendToDSLROfficer: "Send to DySLR Officer",
  EnterRemarks: "Enter remarks...",
  DocumentView: "View",
  SendToDSLR: "Send to DySLR Officer",
  ProceedConfirmation: "You are about to proceed",
  ProceedNote: "Do you really want to continue? There are still some surveys left to be verified.",
  SendToSurveyor: "Send to Surveyor",
  SelectUserSurveyor: "Select User (Surveyor)",
  SendBackToDSLR: "Send to DSLR ",
  SelectUser: "Select User",
  SendBackToDSLRText: "Send Back to DSLR Officer",
  SendToConcernValuer: "Send to Concern Valuer",
  SelectConcernValuerUser: "Select Concern Valuer User",
  completing: "Completing...",
  loading_officers: "Loading officers...",
  select_officer: "Select officer",
  selectUserTehsildarOfficer:"Select User Tehsildar",


  //MeasuementViseObjection
  MeasurementDetails: "Measurement Details",
  MeasuredArea: "Measured Area",
  ClaimedArea: "Claimed Area",
  SpecificObjections: "Specific Objections",
  TreeObjectionDetails: "Tree Objection Details",
  StructureObjectionDetails: "Structure Objection Details",
  WaterBodyObjectionDetails: "Water Body Objection Details",
  OtherRemarks: "Other Remarks",
  Attachments: "Attachments",
  AttachSurveyPlan: "Attach Survey Plan",
  UploadSurveyPlan: "Upload Survey Plan",
  MaxSurveyPlanSize: "(Max size: 1MB)",
  UploadPhotos: "Upload Photos",
  MaxPhotoSize: "(Max size: 1MB per file, 5MB total)",
  FilesUploaded: "file(s) uploaded",
  Select: "Select",


  //ObjectionList
    SearchObjections: "Search objections...",
  Section15: "Section 15",
  Objections: "objections",
  SendToSLR: "Send to SLR",
  SelectUserSLR: "Select User (Dy.SLR)",
  SendToSLRButton: "Send to SLR",
  CreateObjection: "Create Objection",

  //PAP
  RehabilitationForm: "Rehabilitation form",
  DownloadPDF: "Download PDF",
  SharePAPDetails: "Share PAP Details",
  PAPOwner: "PAP Owner:",
  Facebook: "Facebook",
  Twitter: "Twitter",
  WhatsApp: "WhatsApp",
  ShowAllRecords: "Show All Records",
  SearchPAPs: "Search PAPs...",
  SelectLocationMessage: "Please select District, Taluka, and Village to view filtered PAP data.",
  FilteredBy: "Filtered by",
  TotalPAPs: "Total PAPs",
  Average: "Avg",
  Paid: "Paid",
  AcquireArea: "Acquire Area",
  FinalAmount: "Final Amount",
  PaymentDate: "Payment Date",
  PAPID: "PAP ID",
  ShowingToOfResults: "Showing to of results",
  SelectLocationToViewData: "Please select District, Taluka, and Village to view filtered data",
  NoPAPDataFound: "No PAP Data Found",
  NoProjectAffectedPersons: "No project affected persons found for the current criteria.",
  ClearSearch: "Clear Search",
  NoProjectSelected: "No Project/Proposal Selected",
  GoBackMessage: "Please go back to the dashboard and select a project and proposal",
  GoBackToDashboard: "Go Back to Dashboard",
  InitializingPAPData: "Initializing PAP data...",


  //PrivateObjection
  ok: "OK",
  verifyYourEmail: "Verify Your Email",
  otpSentMessage: "We've sent a 6-digit OTP to",
  enterOtp: "Enter OTP",
  checkEmailForOtp: "Please check your email and enter the OTP to complete the submission.",
  verifyOtp: "Verify OTP",
  dismiss: "Dismiss",
  verifyOwnerDetails: "Verify Owner Details",
  verify: "Verify",
  enterYourName: "Enter your name",
  representativeDetails: "Representative Details (If applicable)",
  treesAssessment: "Trees Assessment",
  structuresAssessment: "Structures Assessment",
  titleOwnershipIssues: "Title/Ownership Issues",
  recordedArea: "Recorded Area",
  recordedCompensation: "Recorded Compensation (₹)",
  expectedCompensation: "Expected Compensation (₹)",
  numberOfTreesRecorded: "Number of Trees Recorded",
  numberOfTreesClaimed: "Number of Trees Claimed",
  charactersRemaining: "characters remaining",

  //ProjectDetails
  LoadingProjectDetails: "Loading project details...",
  ProjectNotFound: "Project not found",
  ProjectNotFoundMessage: "The requested project could not be found",
  GoBack: "Go Back",
  BackToProjects: "Back to Projects",
  Export: "Export",
  ProjectProgress: "Project Progress",
  Expected: "Expected",
  Parcels: "Parcels",
  State: "State",
  Coordinates: "Coordinates",
  ProjectBy: "Project By",
  ProjectAreaBreakdown: "Project Area Breakdown",
  PendingArea: "Pending Area",
  RoadLength: "Road Length",
  ProjectTimeline: "Project Timeline",
  ProjectStakeholders: "Project Stakeholders",
  ProjectImages: "Project Images",
  ProjectDocuments: "Project Documents",

  //ProjectManagemengt
  noProjectsFound: "No projects found",
  adjustSearchCriteria: "Try adjusting your search criteria or filter settings to find what you're looking for",
  clearFilters: "Clear filters",
  addNewProject: "Add new project",
  division: "Division",
  acquisitionNo: "Acquisition No",
  orderNo: "Order No",
  orderDate: "Order Date",
  tehsil: "Tehsil",
  noOfBudharak: "No. of Budharak",
  legacy: "Legacy",

  //Proposal
  loadingProposals: "Loading proposals...",
  proposalManagement: "Create/Edit Proposal",
  totalRecords: "Total Records",
  proposalId: "Proposal ID",
  requiredAcquisitionArea: "Required Acquisition Area",
  exemption: "Exemption",
  publish: "Publish",
  noProposalsFound: "No proposals found",
  showingProposals: "Showing proposals",
  clearSelection: "Clear selection",
  Download:"Download",
  addProposal: "Add Proposal",
  searchProposals: "Search proposals...",
  selectDistrictTalukaVillage: "Please select District, Taluka, and Village to view proposal data.",
  locationSelected: "Location selected",
  viewDataPrompt: "Please select District, Taluka, and Village to view data",
  sendToSamanvay: "Send to Samanvay",
  sendingToSamanvay: "Sending to Samanvay",
  selectSamanvayOfficerOption: "Select Samanvay Officer",
  document: "Document",
  Send: "Send",
  sendingToCollector: "Sending selected proposal(s) to Collector",
  selectCollector: "Select Collector",
  trackingHistory: "Tracking History",
  noDocument: "No Document",
  noTrackingHistory: "No Tracking History",
  proposalNotProcessed: "This proposal hasn't been processed through any stages yet.",
  lastUpdated: "Last updated",
  documentViewer: "Document Viewer",
  openOriginal: "Open Original",
  failedToLoadImage: "Failed to load image",
  previewNotAvailable: "Preview not available",
  cannotPreviewInBrowser: "This document type cannot be previewed in the browser",
  downloadAndOpen: "Download & Open",
  namunak: "Namuna K",

  //ProposalDetails
  LandAcquisitionProposal: "Land Acquisition Proposal",
  ProposalBudget: "Proposal Budget",
  AcquiredAgency: "Acquired Agency",
  FileSelected: "File selected",
  SubmitProposal: "Submit Proposal",
  AddLandAcquisitionProposal: "Add Land Acquisition Proposal",
  ToBeAcquisitionLandArea: "To Be Acquisition Land Area",


  //ReportLandAcquisition
  loadingLandHoldings: "Loading land holdings data...",
  errorLoadingData: "Error Loading Data",
  debugInformation: "Debug Information:",
  selectedProject: "Selected Project",
  currentProjectId: "Current Project ID",
  apiResponseDebug: "API Response Debug",
  testApi: "Test API",
  noDataAvailable: "No Data Available",
  noLandHoldingsFound: "No land holdings found for this project",
  apiResponse: "API Response",
  downloadOptions: "Download Options",
  printPdf: "Print/PDF",
  ProjectKeys: "Project Object Keys",


  //Reports
  ReportsGeneration: "Reports Generation",
  ReportsDescription: "Generate various reports for land acquisition projects",  
  ReportType: "Report Type",
  Generating: "Generating...",
  Preview: "Preview",
  Downloading: "Downloading...",
  ReportPreview: "Report Preview",
  ClosePreview: "Close Preview",

  //RoleManagement
  Please_wait_while_we_fetch_the_user_data: "Please wait while we fetch the user data",
  users: "users",
  Select_Role: "Select Role",
  Assigned_Projects_and_Proposals: "Assigned Projects and Proposals",
  searchuserproject: "Search users or projects...",
  SearchUsername: "Search username",

  //Searchbar
  projectRequired: "Project Required",
  selectProjectSearch: "Please select a project to use the search functionality.",
  landRecordsSearch: "Land Records Search",
  landRecordsSearchDesc: "Search and manage land records efficiently",
  searchFilters: "Search Filters",
  enterName: "Enter Name",
  surveyGatNumber: "Survey/Gat Number",
  enterSurveyGatNumber: "Enter Survey/Gat Number",
  selectDistrictTalukaFirst: "Select District & Taluka first",
  clearAll: "Clear All",
  searchingRecords: "Searching records...",
  searchError: "Search Error",
  searchResults: "Search Results",
  Found: "Found",
  noRecordsFound: "No records found",
  clearSearch: "Clear Search",
  readyToSearch: "Ready to search",
  enterCriteria: "Enter any search criteria above to find land records",
  nameShort: "Name",
  mobileShort: "Mobile",
  surveyNoShort: "Survey No",
  districtShort: "District",
  talukaShort: "Taluka",
  villageShort: "Village",

  //UserManagement
  searchuser: "Search users ",
  addNewUser: "Add New User",
  projectManagerCoordinator: "Project Manager / Coordinator",
  surveyor: "Surveyor",
  collector: "Collector",
  verifier: "Verifier",

  //UserProfile
  loadingProfile: "Loading Profile",
  fetchingLatestInfo: "Fetching your latest information...",
  complete: "Complete",
  manageAccountPreferences: "Manage your account and preferences",
  themeColors: "Theme Colors",
  notifications: "Notifications",
  privacy: "Privacy",
  exportJson: "Export JSON",
  profileCompletion: "Profile Completion",
  profile: "Profile",
  skillsExperience: "Skills & Experience",
  achievements: "Achievements",
  analytics: "Analytics",
  security: "Security",
  dropImageHere: "Drop image here",
  binaryImageData: "Binary Image Data",
  filename: "Filename",
  online: "Online",
  experience: "Experience",
  rating: "Rating",
  bio: "Bio",
  socialLinks: "Social Links",
  github: "GitHub",
  linkedin: "LinkedIn",
  twitter: "Twitter",
  enterDistrict: "Enter your district",
  professionalInfo: "professional Info",
  designation: "designation",
  department: "department",
  binaryStorageEnabled: "Binary storage enabled",
  skillsTechnologies: "Skills & Technologies",
  experienceOverview: "Experience Overview",
  totalExperience: "Total Experience",
  yearsInField: "Years in the field",
  projectsCompleted: "Projects Completed",
  successfulDeliveries: "Successful deliveries",
  clientRating: "Client Rating",
  avgFeedbackScore: "Average feedback score",
  achievementsRecognition: "Achievements & Recognition",
  profileAnalytics: "Profile Analytics",
  profileViews: "Profile Views",
  profileShares: "Profile Shares",
  connections: "Connections",
  growthMetrics: "Growth Metrics",
  ProfileCompletion: "Profile Completion",
  securitySettings: "Security Settings",
  twoFactorAuth: "Two-Factor Authentication",
  addExtraSecurity: "Add an extra layer of security to your account",
  enable2FA: "Enable 2FA",
  loginHistory: "Login History",
  viewRecentLogin: "View your recent login activity",
  viewHistory: "View History",
  privacySettings: "Privacy Settings",
  managePrivacy: "Manage Privacy",
  manageprofile: "Manage who can see your profile information",
  profileQRCode: "Profile QR Code",
  scanToViewProfile: "Scan to view profile",
  deleteProfileImage: "Delete Profile Image",
  confirmDeleteProfileImage: "Are you sure you want to delete your profile image?",
  WelcomeMessage: "Welcome to my profile! I'm passionate about technology and innovation.",
  Default : "Default",
  Setdefault : "Set-Default"  ,

  //ViewMeasurementList
  loadingMeasurementDetails: "Loading measurement details...",
  noMeasurementData: "No measurement data available",
  stageError: "Previous Step is not Completed",
  confirmDownload: "Confirm Download",
  confirmDownloadMessage: "Are you sure you want to download the measurement report?",
  occupantsManagement: "Occupants Management",
  addOrManageOccupants: "Add or manage property Occupants",
  addNewOccupantName: "Add New Occupant Name",
  gatNo: "Gat No.",
  hrm: "H.R.M.",
  areaAfterCounterAcquisition: "AREA TO BE ACQUIRED AFTER COUNTER-LAND ACQUISITION CALCULATION",
  actualOccupantNames: "ACTUAL OCCUPANT NAMES",
  jointCalculationTools: "ACCORDING TO JOINT CALCULATION TOOLS",
  irrigative: "Cultivable",
  nonIrrigative: "Non-Cultivable",
  akoom: "Akoom",
  tree: "Tree",
  crops: "Crops",
  tinshedGodown: "Tinshed/Godown",
  wellLake: "Well ,Lake",
  borewell: "Borewell",
  wireFence: "Wire Fencing",
  occupantSummary: "Occupant Summary",
  contactNo: "Contact No",
  totalOccupantPortion: "Total Occupant Portion",
  occupantLandPortion: "Occupant Land Portion",
  occupantVerificationCompensation: "Occupant Verification & Compensation",
  compensationDetails: "Compensation Details",
  totalPercentage: "Total Percentage",
  identityVerification: "Identity Verification",
  assetCompensationDetails: "Asset Compensation Details",
  noOfTinshed: "No of Tinshed",
  noOfWellLakeShev: "No of Well/Lake/shev", 
  documentManagement: "Document Management",
  viewImages: "View Images",
  uploadNewFiles: "Upload New Files",
  supportedFileTypes: "PDF, JPG, PNG, DOC, DOCX files (Multiple files supported)",
  filesToUpload: "Files to Upload",
  imagePreviews: "Image Previews",
  image: "Image",
  uploading: "Uploading...",
  uploadedSuccessfully: "Successfully Uploaded Files",
  totalFiles: "Total Files",
  uploadedFiles: "Uploaded Files",
  zoom: "Zoom",
  //VillageManagement
  searchVillages: "Search villages, taluka, district...",
  show: "Show",
  commonCauses: "Common causes",
  apiServiceIssues: "API service configuration issues",
  serverNotResponding: "Server is not running or responding",
  authTokenExpired: "Authentication token expired",
  networkIssues: "Network connectivity issues",
  clearSearchResults: "Clear search results",
  villagedata: "Download Village Data",

  //GeneralObjection
  OK: "OK",
  VerifyYourEmail: "Verify Your Email",
  Wevesent6digitOTPto: "We've sent a 6-digit OTP to",
  EnterOTP: "Enter OTP",
  PleasecheckyouremailandenterOTPtocomplete: "Please check your email and enter the OTP to complete the submission.",
  VerifyOTP: "Verify OTP",
  FilePreview: "File Preview",
  PDFDocument: "PDF Document",
  OpenInNewTab: "Open in New Tab",
  Filetypenotsupportedforpreview: "File type not supported for preview",
  Dismiss: "Dismiss",
  ProjectName: "Project Name",
  EnterYourName: "Enter your name",
  UploadIdentityProof: "Upload Identity Proof",
  MaxSize256KB: "(Max size: 256KB)",
  UploadSupportingDocument: "Upload Supporting Document",
  OptionalMaxSize256KB: "(Optional - Max size: 256KB)",
  UploadAnyAdditionalDocuments: "Upload any additional documents that support your objection (e.g., property papers, receipts, photographs)",
  SupportingDocumentUploaded: "Supporting document uploaded",
  EnvironmentalConcerns: "Environmental Concerns",
  ResettlementIssuesLack: "Resettlement Issues Lack",
  ReligiousCulturalSites: "Religious/Cultural Sites",
  TitleOwnershipIssues: "Title/Ownership Issues",
  PublicInterest: "Public Interest",
  OtherObjectionPleaseSpecify: "Other Objection (Please specify)",
  NumberOfTreesRecorded: "Number of Trees Recorded",
  NumberOfTreesClaimed: "Number of Trees Claimed",
  TreeDetailsSpeciesAgeEtc: "Tree Details (species, age, etc.)",
  SubmitObjection: "Submit Objection",
  CharactersRemaining: "characters remaining",
  Matter: "Matter",
  AppointLandSurveyor: "Appoint a land surveyor",
  landAcquisitionAuthorityEcounting: "Land Acquisition Authority has started the E-Counting System for the purpose of calculating the land area",
  feeCollectedByLandAcquisition: "Fee collected by the government for the calculation process by the land acquisition system",
  DatePaymentFeeCollected: "Date of payment of the fee collected by the government for the calculation process by the Land Acquisition Authority",
  JointCensudDate: "Joint census date",
  JointRepresentatives: "Name and designation of the system representatives present at the joint count",
  GeoTaggedPhoto: "Geotagged photo of the officers and employees present",
  MRNo: "M. R. No.",
  BhusampadanNo: "Bhusampadan prakaran No",
  PurposeOfLandAcquisition: "Purpose of Land Acquisition",
  Section21: "Section 21 (1)",
  Section21_1: "Section 21 (1)",
  Section21_1_4: "Section 21 (1),(4)",
  UnderSection21: "Details of claims filed under Section 21",

  Workersjudgment: "After Final Reward",

  //EditOwner


  // EN-----------------------------------------------------------------------
  // PublishProposal
  SendToSamanvayOfficerExtendDate: "Send To Samanvay",
  SendToCollectorExtendDate: "Send To Res.Collector",
  SendBackToLAOExtendDate: "Send To LAO",
  LoadingProposalData: "Loading proposal data...",
  AlreadySentToSamanvay: "Already sent to Samanvay Office",
  ConfirmResubmission: "Confirm Re-submission",
  AlreadySentOnce: "You have already sent once. Do you want to send again?",
  AlreadySentBackToLAO: "Already sent back to LAO",
  PreliminaryNotificationSection11: "Section-11",
  ProposalDetails: "Proposal Details",
  NotPublish: "Not Publish",
  ProposalNumber: "Proposal Number",
  Exemption: "Exemption",
  AcquisitionProposal: "Acquisition Proposal",
  PublishedNewspaper: "Published Newspaper",
  Section11Date: "Date of initial notification",
  Setion11PublicationDate: "Initial notification publication date",
  Section11OneYearDate: "Land Acquisition Lapse date",
  Published: "Published",
  PublicationNo: "Publication No",
  PublicationDate: "Publication Date",
  OfficeofPublication: "Office of Publication",
  DateofPublication: "Date of Publication",
  Documents: "Documents",
  GovernmentGazette: "Government Gazette",
  Newspaper1: "Newspaper - 1",
  Newspaper2: "Newspaper - 2",
  MunicipalCorporation: "Municipal Corporation",
  DistrictCollectorOffice: "District Collector Office",
  SubDivisionalOfficer: "Sub-Divisional Officer",
  TehsilOffice: "Tehsil Office",
  GovernmentNoticeBoard: "Government Notice Board",
  GramSevakOffice: "Gram Sevak Office",
  GramSevakOffice1: "Gram Sevak Office",
  GramPanchayatOffice: "Gram Panchayat Office",
  PreliminaryNotificationunderRule10: "Preliminary Notification under Rule 10 (2) of the Right to Fair Compensation and Transparency in Land Acquisition, Rehabilitation and Resettlement Act, 2013 (Maharashtra Rules, 2014)",
  dateOfNotificationUnderColumn19: "Date of Notification under Sec-19",
  NotPublishedMessage: "Not published - Use the Publish button to publish this proposal",
  AdministrativeOrderDate: "Administrative Order Date",
  AreaFinancialDetails: "Area & Financial Details",
  NoOfLandParcels: "No. of Land Parcels",
  ProposalAmount: "Proposal Amount",
  ExemptionDetails: "Exemption Details",
  ExemptionFile: "Exemption File",
  NoFileAvailable: "No file available",
  PublicationDetails: "Publication Details",
  Proceeding: "Proceeding",
  AdministrativeOrder: "Administrative Order",
  Publication: "Publication",
  AppointedAdministrator: "Appointed Administrator",
  PublishedGazette: "Published Gazette",
  SelectUserDSLR: "Select User (DySLR)",
  SendToLAOOfficer: "Send to LAO Officer",
  SelectUserLAO: "Select User (LAO)",
  SendBackToLAOOfficer: "Send Back to LAO",
  SelectUserCollector: "Res. Collector",
  ThroughSection11: "through section 11",
  EnterAdministrativeOrderNumber: "Enter administrative order number",
  EnterPublicationNumber: "Enter publication number",
  EnterAcquisitionProposalNumber: "Enter acquisition proposal number",
  EnterAdministratorName: "Enter administrator name",
  Publishing: "Publishing...",
  ViewDetail: "View Detail",
  HideDetail: "Hide Detail",
  PublishProposal: "Publish the proposal",
  EnterAdministrativeOrderNo: "Enter administrative order number",
  EnterPublicationNo: "Enter publication number",
  EnterAcquisitionProposalNo: "Enter acquisition proposal number",
  EnterProceedingNo: "Enter proceeding number",

  PublishProposalSendToDSLROfficer: "Send To DySLR",

  // Extend Date
  LoadingExtendDate: "Extend Date Loading...",
  ExtensionDate: "Extend Date",
  NoExtensions: "No Extensions",
  Extend: "Extend",

  // Section -11 Prathmik Adhisuchna
  LoadingPrambhikAdhisuchna: "Loading Prambhik Adhisuchna...",
  ProposalDetail: "Land Acquisition Case Details",
  BhusampadanNumber: "Land Acquisition Number",
  EnterBhusampadanNumber: "Enter Land Acquisition Number",
  BhusampadanDate: "Date",
  EnterMobileNo: "Enter Mobile No.",
  OfficeName: "Office Name",
  EnterOfficeName: "Enter Office Name",
  EnterBranchName: "Enter Branch Name",
  ResendCancelled: "Resend Cancelled",
  AlreadySentToSamanvayOfficerClickToResend: "Already sent to Samanvay Officer. Click to resend.",
  AlreadySentToCollectorClickToResend: "Already sent to Collector. Click to resend.",
  AlreadySentBackToLAOClickToResend: "Already sent back to LAO. Click to resend.",
  selectUserSamanvayOfficer: "Samanvay Officer",
  SuccessfullySentToSamanvayOfficer: "Successfully sent to Samanvay Officer!",
  SuccessfullySentToCollectorOfficer: "Successfully sent to Collector Officer!",
  SuccessfullySentToLAOOfficer: "Successfully sent to LAO Officer!",
  AlreadySentToDSLRClickToResend: "Already sent to DSLR. Click to resend.",
  SuccessfullySentToDSLROfficer: "Successfully sent to DSLR Officer!",

  // Section19
  LoadingSection19: "Loading section-19...",
  Section19Publication: "Section 19 Publication",
  Section19UpdatedSuccessfully: "Section-19 Updated Successfully!",
  Section19PublishedSuccessfully: "Section-19 Published Successfully!",

  //Section15
  Section15Notice: "Section 15 Notice",
  S15Email: "Email",
  S15Phone: "Phone",
  S15FileNumber: "File Number",
  S15Date: "Date",
  S15RecipientDetails: "Recipient Details",
  S15MainContent: "Main Content",

  //Market Value
  MarketGatNumber: "Gat Number",
  EligibleArea: "Eligible Area",
  DeductionReason: "Deduction Reason",
  HectareDeduction: "Hectare Deduction",
  AreaGat: "Area Gat",
  HectareRate: "Hectare Rate",
  MarketPriceChart: "Market price chart",
  MarketAction: "Action",
  LoadingMarketPrices: "Loading market prices...",

  //Undersection21
  AdSrNo: "Sr. No.",
  AdLandholderName: "Landholder Name",
  AdSurveyNumber: "Survey Number",
  AdVillage: "Village",
  AdTotalArea: "Total Area (Hectare/Acre)",
  AdAdvanceAmount: "Advance Amount",
  AdSanctionDate: "Sanction Date",
  AdAction: "Action",
  AdApprovalDate: "Approval order number and date",
  ClaimantName: "Name of the Claimant",
  Address21: "Address",
  ClaimFilingDate: "Date of filing claim before the Land Acquisition Officer",
  ClaimGroupNumber: "Group Number of the Claim",
  ClaimDetails: "Details of the Claim",
  ClaimsUnderSection21: "Claims Under Section 21",
  LAODecisionStatus: "LAO Decision Status",
  Proceedings: "Proceedings",
  Print21: "Print",
  AddNewClaim: "Add New Claim",
  LoadingClaims: "Loading claims...",
  CommentAvailable: "Comment Available",
  NoClaimsFound: "No claims found under Section 21",
  Documents21: "Documents",
  Cancel21: "Cancel",
  Adding21: "Adding...",
  AddClaim: "Add Claim",
  SrNo21: "S. No",
  Section21ClaimDetails: "Section 21 Claim Details",
  MainInfo: "Main Information",
  Status21: "Status",
  Decision21: "Decision",
  SelectDecision: "Select Decision",
  Approved: "Approved",
  DecisionDate: "Decision Date",
  LAOComment: "LAO Comment",
  EnterDecisionReason: "Enter reason for decision and detailed comment...",
  AdditionalDetails: "Additional Details",
  NotAvailable: "Not Available",
  LoadingProjectInfo: "Project information is loading...",
  Close21: "Close",
  LastUpdated21: "Last updated",
  View21: "View",
  SaveDecision: "Save Decision",
  Processing21: "Processing...",
  CompleteClaimInfo: "Complete claim information and LAO decision",
  Complete21: "Complete",
  Pending21: "Pending",
  GiveLAODecision: "Give LAO Decision",
  Date21: "Date",

  // Compensation
  loadingCompensationData: "Loading Compensation Data",
  pleaseWaitCompensation: "Please wait while we fetch the compensation details...",
  landOwnerId: "LandOwnerID",
  currency: "Currency",
  inr: "INR",
  usd: "USD",
  eur: "EUR",
  compensationStatus: "Compensation Status",
  rejected: "Rejected",
  landValuation: "Land Valuation", 
  valuationDate: "Valuation Date",
  assetValues: "Asset Values",
  interestRate: "Interest Rate",
  interestAmount: "Interest Amount",
  additionalCompensation: "Additional Compensation",
  AdditionalAmount: "Additional Amount",
  reasonAdditionalCompensation: "Reason for Additional Compensation",
  approvalPaymentInformation: "Approval & Payment Information",
  approvalDate: "Approval Date",
  approvalAuthority: "Approval Authority",
  approvalReference: "Approval Reference",
  paymentMode: "Payment Mode",
  paymentReference: "Payment Reference",
  paymentRemarks: "Payment Remarks",
  consentDate: "Consent Date",
  consentReceived: "Consent received from land owner",
  totalCompensationAmount: "Total Compensation Amount",
  calculatedTotal: "Calculated total including all components",
  autoCalculated: "Auto-calculated",
  manualOverride: "Manual Total Compensation Override",
  submitCompensationForm: "Submit Compensation Form",
  LoadingPaymentData: "Loading Payment Data",
  FinalAmountToBePaid: "Final amount to be paid",
  PaidFromBankIFSC: "Paid From Bank IFSC",
  PaidFromAccountNo: "Paid From Account No",
  SubmitPaymentDetails: "Submit Payment Details",
  EnterBankName: "Enter bank name",
  EnterAccountNumber: "Enter account number",
  EnterIFSCCode: "Enter IFSC code",
  EnterAccountHolderName: "Enter account holder name",
  EnterPayingBankIFSC: "Enter paying bank IFSC",
  EnterPayingAccountNumber: "Enter paying account number",
  EnterLandOwnerID: "Enter land owner ID",
  EnterRatePerUnit: "Enter rate per unit",
  EnterTotalLandValue: "Enter total land value",
  EnterStructureValue: "Enter structure value",
  EnterTreeValue: "Enter tree value",
  EnterCropValue: "Enter crop value",
  EnterWaterBodyValue: "Enter water body value",
  EnterOtherAssetValue: "Enter other asset value",
  EnterSolatiumPercentage: "Enter solatium percentage",
  EnterSolatiumAmount: "Enter solatium amount",
  EnterInterestRate: "Enter interest rate",
  EnterInterestAmount: "Enter interest amount",
  EnterAdditionalCompensation: "Enter additional compensation",
  EnterReasonForAdditionalCompensation: "Enter reason for additional compensation",
  EnterPaymentReference: "Enter payment reference",
  EnterPaymentRemarks: "Enter payment remarks",
  EnterApprovalAuthority: "Enter approval authority",
  EnterApprovalReference: "Enter approval reference",
  EnterTotalCompensationAmount: "Enter total compensation amount",
  ManualTotalCompensationOverride: "Manual Total Compensation Override",


  // Compensation Amount
  areaOfSurvey: "Survey Area",
  totalAreaOfSurvey: "Total Survey Area",
  areaAcquired: "Acquired Area",
  compensationCount: "Compensation Count",
  compLand: "Land",
  compStructure: "Structure",
  compTree: "Trees",
  compOthers: "Others",
  compTotal: "Total",
  solatium: "Solatium",
  interest: "12% Interest",
  custom: "Custom",
  rateAmountDisabled: "Rate and amount are disabled due to unavailable measurement",
  loadingCompensation: "Loading Compensation Information...",
  ownersSelected: "Owners Selected",
  sendToFinalAward: "Send to Final Award",
  selectLocationNotice: "Please select district, taluka and village to view compensation data.",
  selectFromFilter: "Please select district, taluka and village from the filter panel above.",
  editCompensationRecord: "Edit Compensation Record",
  ownerId: "Owner ID:",
  updateSuccess: "Compensation record updated successfully!",
  currentRecordInfo: "Current Record Information",
  totalLand: "Total Land",
  acquireLand: "Acquire Land",
  landPrimaryAssets: "Land and Primary Assets",
  landCompensationAmount: "Land Compensation Amount",
  totalLandArea: "Total Land Area",
  acquiredLandArea: "Acquired Land Area",
  rate: "Rate",
  amount: "Amount",
  autoCalculatedAmount: "This amount is automatically calculated from the above fields",
  secondaryAssets: "Secondary Assets",
  compensationCalculations: "Compensation Calculations",
  additionalAmount: "Additional Amount",
  reasonAdditionalComp: "Reason for Additional Compensation",
  interestCalculation: "Interest Calculation",
  interestPeriodDays: "Interest Period (Days)",
  autoInterestCalc: "Automatically calculated from date range",
  interestFromDate: "Interest Start Date",
  interestToDate: "Interest End Date",
  calculatedInterestAmount: "Calculated Interest Amount",
  calcDetails: "Calculation Details:",
  interestPerAnnum: "Per Annum",
  timePeriod: "Time Period",
  years: "Years",
  from: "From",
  liveCalcPreview: "Live Calculation Preview",
  baseAmount: "Base Amount",
  additional: "Additional",
  adminDetails: "Administrative Details",
  compStatus: "Compensation Status",
  updateSuccessShort: "Updated Successfully",
  updateCompensation: "Update Compensation",
  downloadCSV: "CSV Download",
  sendToLao: "Send to LAO",
  proceedWarning: "You are about to proceed",
  continueWarning: "Are you sure you want to continue? Some surveys are still pending verification.",
  RateAndAmountDisabled: "Rate and amount are disabled as count is not available",
  RecordedValuePartialRate: "Recorded Value + Partial Purchase Land Rate per Hectare",
  RecordedValuePartialMarket: "Recorded Value + Partial Purchase Land Market Value",
  MarketValueDoubleFactor: "Land Market Value × 2 Factor",
  TreeValuation: "Tree Valuation",
  ConstructionValue: "Construction Value (House + Tin Shed)",
  WellBorewell: "Well/Borewell (Water Source + Well/Borewell)",
  StructureValuation: "Structure Valuation",
  TotalAmount: "Total Amount",
  ReliefAmount100: "100% Relief Amount",
  ActualOccupant: "Occupant",
  NatureOfOwner:"Owner Type",
  InterestAmountFrom: "Interest Amount From",
  AdvanceCompDeduction: "Advance Compensation Deduction",
  AdvanceInterestDeduction: "Advance Interest Deduction up to 05-04-2023",
  NetPayableAmount: "Net Payable Amount",
  RecordedAreaIrrigable: "Recorded Area (Irrigated)",
  NonIrrigable: "Non-Irrigable",
  TotalAquare: "Total (Square)",
  LandToBeAcquire: "Land to be Acquired",
  Days: "Days",
  CountIsAvailable: "Count is available, rate and amount are disabled as none",

  RateAndAmountDisabledBecauseNo: "Rate and amount are disabled because no",
  PleaseCompleteAllRecordsBeforeSendingToFinalAward: "Please complete all records before sending to Final Award.",
  SuccessfullySentToFinalAwards: "Successfully sent to Final Awards!",

  // FinalReward
  recordsSelected: "records selected",
  sendToKJP: "Send to KJP",
  LandAcquisitionCerti: "Land acquisition certificate",
  recordedValuePartialPurchaseRate: "Recorded Value + Partial Purchase Land Rate per hectare",
  recordedValuePartialPurchaseMarketValue: "Recorded Value + Partial Purchase Land Market Value",
  landMarketValueTwoFactor: "Land Market Value × 2 Factor (No.8 * 2 Factor)",
  treeValuation: "Tree Valuation",
  constructionValue: "Construction Value (Home+Tinshed)",
  wellBorewell: "Well/Borewell (WaterBody + Well/Borewell)",
  structureValuation: "Sturcture Valuation",
  totalAmountSum9to13: "Total Amount (Sum of columns 9+10+11+12+13)",
  reliefAmount100: "100% Relief Amount",
  interest12Percent: "12% Interest Amount ",
  totalAmountSum14to17: "Total Amount (Sum of 14+15+16+17)",
  advanceCompensation50: "50% Advance Compensation Deduction",
  advanceInterest50: "50% Advance Interest Deduction",
  netPayableAmount: "Net Payable Amount(18 - (19+20))",
  recordedAreaIrrigable: "Recorded Area (Cultivable)",
  poKhaNonIrrigable: "Po. Kha(Non-Cultivable)",
  totalAquare: "Total (Aquare)",
  loadingCompensationRecords: "Loading compensation records...",
  tabaPavti: "Taba Pavti",
  downloadFinalVerdict: "Download Final verdict Report",
  choosePreferredDownload: "Choose your preferred download format:",
  confirmationPendingSurveys: "Do you really want to continue? There are still some surveys left to be verified.",
  LoadingFinalAwardData: "Loading Final Award data...",


  // Payment
  paymentManagement: "Payment Management",
  selectFiltersToViewPayment: "Please select District, Taluka, and Village to view payment data.",
  compensationValue: "Compensation Value",
  updatePayment: "Update Payment",
  addCompensation: "Add Compensation",
  selectFiltersToViewPaymentAlt: "Please select District, Taluka, and Village from the filter panel above to view payment data.",
  paymentDetails: "Payment Details",
  paymentInformation: "Payment Information",
  toBankDetails: "To Bank Details",
  fromBankDetails: "From Bank Details",
  NoPaymentRecordsFound: "No payment records found",
  PleaseSelectDistrictTalukaVillageToLoadPaymentData: "Please select District, Taluka, and Village to load payment data",
  ProposalId: "proposalId",


  // KabjaPauti
  ownerSelected: "owner selected",
  sendToPayment: "Send to Payment",
  pleaseSelectLocation: "Please select District, Taluka, and Village to view KJP data.",
  kjpStatus: "KJP Status",
  loadingKjpRecords: "Loading KJP records...",
  kjp: "KJP",
  pendingKjp: "Pending KJP",
  pleaseSelectFromFilter: "Please select District, Taluka, and Village from the filter panel above to view KJP data.",
  compensationRecordDetails: "Compensation Record Details",
  kjpInformation: "KJP Information",
  kjpNumber: "KJP Number",
  kjpDate: "KJP Date",
  kjpRemarks: "KJP Remarks",
  kjpDocument: "KJP Document",
  recordSummary: "Record Summary",
  owner: "Owner",
  current: "Current",
  saveKjpRecord: "Save KJP Record",
  doYouReallyWantToContinue: "Do you really want to continue? There are still some surveys left to be verified",
  KJPDocumentImage: "KJP Document/Image",
  AddKJPRecord: "Add KJP Record",
  EditKJPRecord: "Edit KJP Record",

  SubmitFinalVerdict: "Submit Final Verdict",
  FinalResolution: "Final Resolution",
  EnterDetailedObjectionInfo: "Enter detailed objection information",
  EnterFinalDecision: "Enter the final decision for this hearing...",
  EnterDocumentName: "Enter document name (e.g., Environment Report, Revenue Record)",
  EnterDocumentDescription: "Enter document description",

  //Concern valuer
  AgWirefencing: "Wirefencing",
  AgFarmpond: "Farmpond",
  NoDataAvailableForThisRecord: "No data available for this record",
  TPAgency: "TP Agency",
  AgEdit: "Edit",
  AgAction: "Action",
  Numberofactuals: "Number of actuals",
  Compensationpayable: "Compensation payable (as per valuation report)",
  Agtype: "Type",
  Typesoffruittrees: "Types of fruit trees",
  Foresttype: "Forest type",
  Numericalcount: "JMR count",
  AgSurveyGatNo: "Gat/Survey No",
  Compositenumber: "Composite number",
  Paymentdue: "Payment due",
  PropertyDescription: "Property Description",
  Areaaccordingtojointcalculation: "Area according to joint calculation",
  Yearofconstruction: "Year of construction",
  actualarea: "actual area",
  Agother: "Other",
  Agcactualarea: "Actual area",
  Cubicmeter: "Cubic meter",
  Depthasperjointmeasurement: "Depth as per joint measurement",
  Volumeasperjointmeasurement: "Volume as per joint measurement",
  ActualVolume: "Actual Volume",

  Borewelldepth: "Borewell (depth)",
  Pipelinelength: "Pipeline (length)",
  Homearea: "Home (area)",
  TinShedarea: "TinShed (area)",
  Wirefencingarea: "Wirefencing (area)",
  Wellvolume: "Well (volume)",
  Farmpondvolume: "Farmpond (volume)",
  OtherAssetarea: "Other Asset (area)",

  //Common
  CommonSave: "Send",
  SidebarSection21_1: "Section21_1",
  SidebarSection21_1_4: "Proceedings of Section 21_1_4",
  SideBarSection19: "Declaration of Article 19",
  //Digital Signature
  // Signature Pad
  DrawSignatureArea: "स्वाक्षरी क्षेत्रे काढा",
  SignNote: "स्वाक्षरी बॉक्स तयार करण्यासाठी क्लिक करा आणि ड्रॅग करा. तुम्ही कोणत्याही पृष्ठावर अनेक स्वाक्षऱ्या जोडू शकता.",
  AddSignature: "स्वाक्षरी जोडा",
  ConfirmAllSignature: "सर्व स्वाक्षऱ्यांची पुष्टी करा",



  Punarbhu: "PUNARBHU",
  Punarbhu1: "Land Acquisition Portal",

  //JMR
  editpropertyoccupant: "Fill information of Assets Attatched to Land",
  Joverview: "Overview",
  Jtree: "Trees",
  Jhouse: "Houses",
  Jtinshed: "Tin Shads",
  Jwire: "Wire Fencing",
  Jfarmpond: "Farm Ponds",
  Jwells: "Wells",
  Jborewells: "Borewells",
  Jpipeline: "Pipelines",
  Jothers: "Others",
  Jlocation: "Location",
  Jremark: "Remarks",
  propertyoverview: "Property Overview",
  areasatbar: "Area according to 7/12",
  culti: "Cultivable",
  nonculti: "Non-Cultivable",
  Jtotal: "Total",
  areaJMR: "Area According to JMR",
  JoccupantInformation: "Occupant Information",
  natureofacquisition: "Nature Of Acquisition",
  number: "Contact Number",
  Jaddress: "Address",
  AssetsSummary: "Assets Summary",
  category:"category",
  treemanagement: "Trees Management",
  addTree: "Add Tree",
  notreeadded: "No trees added yet",
  Jselectcategory: "Select category",
  treetype: "Tree Type",
  Jselecttreetype: "Select Type",
  captureimage: "Capture Image",
  Jview: "View",

  homesManagement: "Homes Management",
  addhome: "Add Home",
  nohomeadded: "No Homes added yet",
  constructionType: "Construction Type",
  floortype: "Floor Type",
  length: "length (m)",
  width: "width (m)",
  height: "height (m)",
  selectfloor: "Select Floor",
  groundfloor: "Ground Floor",
  ffloor: "1st Floor",
  sfloor: "2nd Floor",

  //Form Sheel
  formSell: 'Form C',
  kalam37_2: 'Section 37(2)',

  //Tehsildar
  SendToTehsilar: 'Send to Tehsildar',
  punarSendToTehsilar: 'Send to Tehsildar',
  Tehsilar: 'Land Record Updation',

  Section20ANotification: 'Section 20A Notification',

  //Land Beneficiary Letter
  landBeneficiaryLetter: 'Land Beneficiary Letter',
  objection: "Objection",
  objectionReport: 'objection Nirakaran Prasidhi Report',
  objectionComments: 'objection comments',


  //Family Survey No
  FamilySurveyForm: 'Family Survey Form',

  //WorkAssign
  WorkAssign: 'Work Assign',
  assignToSurveyor: "Assign to Surveyor",
  OtherDocuments: "Other Documents",
  AllDocuments: "All Documents",

  Section19heading: "Fund requirement-Section 19",

  //FundRequestReceived
  FundRequestReceived: "Fund Request/Received",
  FundRequestDate: "Fund Requested Date",
  FundRequest: "Fund Request",
  ReceiveFundDate: "Receiving Fund Date",
  ReciveFund: "Receive Funds",
  ChequeAmount: "Cheque Amount",
  ChequeDate: "Cheque Date",
  ReceiveAmount: "Received Amount",
  FinalAwardheading: "Funds required-final award",
  SelectUserProjectIncharge: "Select Project Incharge",
  SendToProjectIncharge11: "Send To ProjectIncharge for Section11",
  SendToProjectIncharge19: "Send To ProjectIncharge for Section19",
  RequestedFund: "Requested Fund",

  // ExtendedDate
  ExtendedDate: "Extended Date",
  ExtendedDate11: "Section 19 time extention",
  ExtendedDate19: "Final Award time extention",
  Section19Date: "Section 19 Date",
  Setion19PublicationDate: "Section 19 Publication Date",
  Section19OneYearDate: "Section 19 Expiry Date",

  namunaA: "Namuna_A",

  namunaB: "Namuna_B",
  namunaK: "Namuna_K",

  landAllocationReport: "Land Allocation Report",
  kalam11: "Kalam 11(1)",
  landBeneficiaryReport: "Land Beneficiary Report",
  landBeneficiaryList: "Land Beneficiary List",
  landObjectionRegister: "Land Objection Register",
  finalLandAllotmentList: "Final Land Allotment List",
  finalLandAllotmentLetter: "Final Land Allotment Letters",
  tabaPautiTippaniLetters: "Taba Pauti Tippani Letters",
  tabaPautiPunarvarshan: "Taba Pauti",
  PlotAllotmentLetter: "Plot Allotment Letter",

  //send to DRO
  SuccessfullySentToDRO: " Successfully sent to DRO!",
  selectUserDROOfficer: "Select User (DRO Officer)",

  searchRecords: "Search Records",

  //Railway
  section20A: "Section 20A",
  section20B: "Section 20B",
  section20D: "Section 20D",
  section20E: "Section 20E",
  section20F: "Section 20F",
  section20G: "Section 20G",
  section20I: "Section 20I",
  section20F_6: "Section 20F(6)",
  appealLies: "Appeal Lies",

  //RailwayProposal
  railwayProposal: "Railway Proposal",
  createRailwayProposal: "Create Railway Proposal",
  editRailwayProposal: "Edit Railway Proposal",
  viewRailwayProposal: "View Railway Proposal",
  railwayLandHoldingList: "Railway LandHolding List",
  namuna_Kh: "Namuna Kh",
  docu7_12: "Document 7/12",
  eight_A: "Document 8/A",
  villageMap: "Village Map",
  creditorList: "Creditor List",
  acquisitionBoundaryAndArea: "Acquisition Boundary And Area",
  privateLandForm1: "Private Land Form 1",
  privateLandForm2: "Private Land Form 2",
  introduction: "Introduction",
  // parishtisht_A: "Parishtisht A",
  Parishtisht_ASubmissionLetter: "Parishtisht A SubmissionLetter",
  annexure_E: "Annexure E",

  railwayFundRequest: "Railway Fund Request",
  railwayJointMesurmentList: "20(B) JointMesurmentList",
  railwayAdvancePayment: "Railway AdvancePayment",
  railwayObjectionList: "20(D) ObjectionList",
  railwayExtendedDate: "Railway ExtendedDate",
  railwaySection19: "20(E) Section19",
  railwaySection21: "Railway Section21",
  railwayMarketValue: "Railway MarketValue",
  railwaySection93: "Railway Section93",
  railwayExtendedDate19: "Railway ExtendedDate19",
  railwaySelectFormat: "20(F) SelectFormat",
  railwayFinalReward: "20(G) FinalReward",
  railwayWorkersJudgment: "20(I) Taba Pauti",
  railwayPayment: "Railway Payment",
  railwayPAP: "Railway PAP",
  railwayPunavarshan: "Railway Punavarshan",
  railwaySearchBar: "Railway Search Bar",
  railwayPublishProposal: "(20A) Publish Proposal",

  //Highway
  section3A: "Section 3a",
  section3A_Eng: "Section 3A",
  cala: "Competent authority for Land acquisition",
  highwayFundRequestReceived: "Fund Request Received",
  section3B: "Section 3B",
  section3C: "Section 3C",
  section3D: "Section 3D",
  section3G: "Section 3G",
  section3H: "Section 3H",
  tabaPauti: "Taba Pauti",
  highwayAddLand: " Add Land-Holding",
  highwayPublishProposal: " Publish Proposal",
  HighwayCoveringLetters: " Covering Letters",

  //HighwayProposal
  highwayProposal: "Proposal",
  createHighwayProposal: "Create Proposal",
  editHighwayProposal: "Edit Proposal",
  viewHighwayProposal: "View Proposal",

  //HighwayLandHolding
  highwayLandHoldingList: "Highway LandHolding List",
  highwayJointMesurmentList: "3(B) Joint MesurmentList",
  highwayAdvancePayment: " Advance Payment",
  highwayobjectionList: "3(C) Objection List",
  highwayExtendedDate11: " Extended Date Section 11",
  highwayExtendedDate: " Extended Date",
  highwayCoveringLettersSection19: "3(C) Section 19 Covering Letter",
  highwayTehsildar: "Section 3(D) Declaration of Article 19",
  highwaySidebarSection21_1_4: "Proceedings of Section 21_1_4",
  highwaySection21: "Section 21 (1)",
  highwaySection21_1: "Section 21 (1)",
  highwaySection21_1_4: "Section 21 (1),(4)",
  highwayUnderSection21: "Details of claims filed under Section 21",
  highwayReportLandAcquisition: "Highway Report Land Acquisition",
  highwayAnusuchi1: "Highway Anusuchi 1",
  highwayAnusuchi2: "Highway Anusuchi 2",
  highwayAnusuchi3: "Highway Anusuchi 3",
  highwayAnusuchi4: "Highway Anusuchi 4",
  highwayAnusuchi5: "Highway Anusuchi 5",
  highwayAnusuchi6: "Highway Anusuchi 6",
  highwayAnusuchi7: "Highway Anusuchi 7",
  highwayOtherDocuments: "Highway Other Documents",

  highwayMarketValue: "Market value of land",
  highwayMarketValueBail: "Market Value of the bail",
  highwayDirectPurchase: "Direct Purchase",
  highwayConcernValuer: "Concern Valuer",
  highwaySection93: "Section 93",
  highwayExtendedDate19: "Extend the time period for declaration under Section Final Award",
  highwaySelectFormat: "3(G) Select Format",
  highwayfinalaward: "Final-Award",
  highwayWorkersjudgment: "Possession of Land",
  highwayPayment: "3(H) Payment",
  highwayProjectAffectedPerson: "Project Affected Person",
  highwayPunavarshan: "Punavarshan",
  highwaySearchBar: "Search Bar",
  highwayTehsilar: "Tehsildar",


  BackToProjectIncharge: "Send backto ProjectIncharge ",
  Tehsilar:"Tehsildar",

};

export default translations;